<template>
    <div class="room_main" :class="{'cn':version=='1'}">
        <div class="room_left">
            <!-- <side-bar></side-bar> -->
        </div>
        <div class="room_right">
            <div class="room_right_top">
                <div class="right_top_l">
                    <div class="switch_box">

                    
                        <div class="div" :class="{'select':roomType == '1'}" @click="roomTypeFun('1')">
                            <template v-if="domainName != 'uvlight'">
                                {{hotelType==1?$t('App.sideBar.text16'):$t('App.room.text1')}}
                            </template>
                            <template v-if="domainName == 'uvlight'">
                                {{$t('App.sideBar.text19')}}
                            </template>
                        </div>
                        <div class="div" :class="{'select':roomType == '2'}" @click="roomTypeFun('2')">{{$t('App.room.text2')}}</div>
                    </div>
                    <el-select v-model="buildId" @change="buildChange">
                        <el-option
                            v-for="item in buildNav"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <el-input :placeholder="$t('App.room.text3')" v-model="keywords" @keyup.native="getroomListKeyUp($event,'search')" class="input-with-select">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="getroomList('search')"></i>
                    </el-input>
                </div>
                <div class="right_top_r">
                    <template v-if="roomType == '1'">
                        <div class="btn" @click="floorPlanFun()"><i class="iconfont icon-FloorPlan"></i><span>{{$t('App.room.text4')}}</span></div>
                        <div class="btn" @click="centralizedSettingFun()"><i class="iconfont icon-Centralizedsetting"></i><span>{{$t('App.room.text5')}}</span></div>
                    </template>
                    <template v-if="roomType == '2'">
                        <div class="btn" @click="bindingTkOpen()" v-if="bindingTkOpenShow"><img :src="img_bindingTkOpen"><span>{{$t('App.room.text6')}}</span></div>
                        <div class="btn" @click="floorplanTkOpen()"><i class="iconfont icon-FloorPlan"></i><span>{{$t('App.room.text7')}}</span></div>
                        <div class="btn" @click="mapDeviceFun()"><img :src="img_lights_0"/><span>{{$t('App.room.text8')}}</span></div>
                    </template>
                </div>
            </div>
            <div class="room_right_main">
                <div class="room_right_main_l scrollbar_style" @scroll="scrollNavFun">
                    <div class="ul">
                        <div class="li" :class="{'select':item.id == floorId}" @click="floorSelectFun(item,index)" v-for="(item,index) in floorRoomList" :key="'floor_'+item.id">{{item.name}}</div>
                    </div>
                </div>
                <div class="border_t" v-if="roomRightMainLB == 1"></div>
                <div class="border_b" v-if="roomRightMainLB == 2"></div>
                <div class="room_right_main_r scrollbar_style" v-if="roomType == '1'" key="roomType_1" v-loading="loading.roomList">
                    <div class="ul">
                        <div class="li" :class="{'select':item.id == 10}" @click="linkToFun(item,'/room-light')" v-for="item in roomList" :key="'room_'+item.id">
                            <div class="seting_btn" @click.stop="openRoomPlan(item)">
                                <i class="el-icon-setting"></i>
                            </div>
                            <div class="box1">
                                <div class="img_box">
                                    <img :src="item.image" :onError="imgErrorSrc">
                                </div>
                                <div class="lightsNumber">
                                    <div class="div1">
                                        <p class="p1">
                                            <template v-if="hotelType==0">{{$t('App.room.text10')}}</template>
                                            <template v-if="hotelType==1">{{$t('App.sideBar.text3')}}</template>
                                        </p>
                                        <p class="p2">
                                            <template v-if="hotelType==0">{{item.lightDeviceOnlineCount}}/{{item.lightDeviceCount}}</template>
                                            <template v-if="hotelType==1">{{item.classroomLightCount}}</template>
                                        </p>
                                    </div>
                                    <div class="div2">
                                        <p class="p1">
                                            <template v-if="hotelType==0&&domainName != 'plant'">{{$t('App.room.text10_')}}</template>
                                            <template v-if="hotelType==0&&domainName == 'plant'">{{$t('App.sideBar.text24')}}</template>
                                            <template v-if="hotelType==1">{{$t('App.sideBar.text4')}}</template>
                                        </p>
                                        <p class="p2">
                                            <template v-if="hotelType==0">{{item.cirDeviceOnlineCount}}/{{item.cirDeviceCount}}</template>
                                            <template v-if="hotelType==1">{{item.blackboardLightCount}}</template>
                                        </p>
                                    </div>
                                    <div class="div3">
                                        <p class="p1">
                                            <template v-if="hotelType==0">{{$t('App.room.text11')}}</template>
                                            <template v-if="hotelType==1">{{$t('App.sideBar.text6')}}</template>
                                        </p>
                                        <p class="p2">
                                            <template v-if="hotelType==0">{{item.sensorOnlineCount}}/{{item.sensorCount}}</template>
                                            <template v-if="hotelType==1">{{item.curtainDeviceCount}}</template>
                                        </p>
                                    </div>
                                    <div class="div4">
                                        <p class="p1">
                                            <template v-if="hotelType==0">{{$t('App.room.text12')}}</template>
                                            <template v-if="hotelType==1">{{$t('App.sideBar.text5')}}</template>
                                        </p>
                                        <p class="p2">
                                            <template v-if="hotelType==0">{{item.airPurOnlineCount}}/{{item.airPurCount}}</template>
                                            <template v-if="hotelType==1">{{item.panelDeviceCount}}</template>
                                        </p>
                                    </div>
                                </div>
                                <div class="text_box">
                                    <p class="p2">{{$t('App.room.text1')}}</p>
                                    <p class="p1" :title="item.number">{{item.number}}</p>
                                </div>
                            </div>
                            <div class="box2">
                                <div class="div1">
                                    <p class="p1">PM2.5</p>
                                    <p class="p2" :style="{'color':classificationColorArr2[item.PM25_level]}">{{item.PM25}}</p>
                                    <p class="p3">µg/m³</p>
                                </div>
                                <div class="div2">
                                    <p class="p1">PM10</p>
                                    <p class="p2" :style="{'color':classificationColorArr2[item.PM10_level]}" v-if="item.PM10!=0">{{item.PM10}}</p>
                                    <p class="p2" :style="{'color':classificationColorArr2[item.PM10_level]}" v-if="item.PM10==0">{{'-'}}</p>
                                    <p class="p3">µg/m³</p>
                                </div>
                                <div class="div3">
                                    <p class="p1">CO₂</p>
                                    <p class="p2" :style="{'color':classificationColorArr2[item.CO2_level]}">{{item.CO2}}</p>
                                    <p class="p3">ppm</p>
                                </div>
                                <div class="div3">
                                    <p class="p1">TVOC</p>
                                    <p class="p2" :style="{'color':classificationColorArr2[item.TVOC_level]}">{{item.TVOC}}</p>
                                    <p class="p3">ppb</p>
                                </div>
                                <div class="div3">
                                    <p class="p1">{{$t('App.dashboard.text13')}}</p>
                                    <p class="p2" :style="{'color':classificationColorArr2[item.HCHO_level]}">{{item.HCHO}}</p>
                                    <p class="p3">ppb</p>
                                </div>
                                <div class="div4">
                                    <p class="p1">{{$t('App.room.text76')}}</p>
                                    <p class="p2">{{item.Temp}}</p>
                                    <p class="p3">℃</p>
                                </div>
                                <div class="div4">
                                    <p class="p1">{{$t('App.room.text77')}}</p>
                                    <p class="p2">{{item.RH}}</p>
                                    <p class="p3">RH%</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p v-if="roomList.length == 0">{{$t('App.room.text14')}}</p>
                </div>
                <div class="room_right_main_map_bg scrollbar_style" v-if="roomType == '2'" key="roomType_2" v-loading="loading.mapDevList">
                    <div class="room_right_main_map" :style="{'background-image':'url('+layoutImage+')'}" ref="planebaseMap">
                        <div class="map_tips">
                            <div class="div1">
                                <p class="p1"><span><i></i><span class="span1">{{$t('App.room.text15')}}</span></span><span class="span2">{{planeLayoutDevInfo.onlineCount}}</span></p>
                                <p class="p2"><span><i></i><span class="span1">{{$t('App.room.text16')}}</span></span><span class="span2">{{planeLayoutDevInfo.newCount}}</span></p>
                                <p class="p3"><span><i></i><span class="span1">{{$t('App.room.text17')}}</span></span><span class="span2">{{planeLayoutDevInfo.alarmCount}}</span></p>
                            </div>
                            <div class="div2">
                                <div><img :src="img_lights_3"><p>{{planeLayoutDevInfo.airCount}}</p></div>
                                <div><img :src="img_lights_2"><p>{{planeLayoutDevInfo.sensorCount}}</p></div>
                                <div class="circadianLights"><img :src="img_lights_1"><p>{{planeLayoutDevInfo.cirLightCount}}</p></div>
                                <div><img :src="img_lights_0"><p>{{planeLayoutDevInfo.lightCount}}</p></div>
                            </div>
                            <div class="div3"><i class="iconfont icon-tuli"></i></div>
                        </div>
                        <div :class="'map_device type_'+item.type+' '+item.id +' status_'+item.status+' frameSelection_'+item.frameSelection" :style="{top:item.locationY,left:item.locationX,width:clientWidth+'px',height:clientHeight+'px'}" v-for="(item) in mapDevList" :key="'map_device '+item.type+' '+item.id"></div>
                        <div class="frame_selection" :style="{top:frameSelectionTop+'px',left:frameSelectionLeft+'px',width:frameSelectionWidth+'px',height:frameSelectionHeight+'px'}" v-show="frameSelectionShow"><div class="move" v-if="frameSelectionIsShow"></div></div>
                        <div ref="device_tips" class="device_tips" :style="{top:deviceInfo.locationY,left:deviceInfo.locationX}" v-show="deviceTipsShow">
                            <p><span class="span1">{{$t('App.room.text18')}}</span><span class="span2">{{deviceInfo.id}}</span></p>
                            <p><span class="span1">{{$t('App.room.text43')}}</span><span class="span2">{{deviceInfo.deviceId}}</span></p>
                            <!-- <p><span class="span1">{{$t('App.room.text19')}}</span><span class="span2">{{deviceInfo.number}}</span></p> -->
                            <p><span class="span1">{{$t('App.room.text20')}}</span><span class="span2">{{mapDeviceTypeList[deviceInfo.type].name}}</span></p>
                            <p><span class="span1">{{$t('App.room.text21')}}</span><span class="span2">{{deviceInfo.status}}</span></p>
                            <p><span class="span1">{{$t('App.room.text22')}}</span><span class="span2">{{floorName}}</span></p>
                            <p><span class="span1">{{$t('App.room.text23')}}</span><span class="span2">{{deviceInfo.roomNumber}}</span></p>
                        </div>
                        <div class="right_click_menu_box" v-if="rightClickMenuShow">
                            <div class="right_click_menu_bg" @click="rightClickMenuClose()"></div>
                            <div class="right_click_menu" :style="{top:rightClickMenuTop,left:rightClickMenuLeft}">
                                <div class="div div1" v-if="rightClickMenu_copy_Show" @click="mapDeviceCopy()">
                                    <i></i>
                                    <span>{{$t('App.room.text24')}}</span>
                                </div>
                                <div class="div div2" v-if="rightClickMenu_paste_Show" @click="mapDevicePaste()">
                                    <i></i>
                                    <span>{{$t('App.room.text25')}}</span>
                                </div>
                                <div class="div div3" v-if="rightClickMenu_delete_Show" @click="mapDeviceDel()">
                                    <i></i>
                                    <span>{{$t('App.room.text26')}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="click_menu_move" :style="{top:clickMenuMoveTop+'px',left:clickMenuMoveLeft+'px'}" v-if="clickMenuMoveShow">
                            <div class="click_menu_move_top">
                                <!-- <img src="../img/room/map/move_top.png"> -->
                            </div>
                            <div class="div div1" @click="mapDeviceCopy('click')">
                                <i></i>
                                <span>{{$t('App.room.text24')}}</span>
                            </div>
                            <div class="div div2" @click="mapDevicePaste('click')" :class="{'select':mapDevicePasteIsTrue}" v-if="rightClickMenu_paste_Show">
                                <i></i>
                                <span>{{$t('App.room.text25')}}</span>
                            </div>
                            <div class="div div3" @click="mapDeviceDel('click')">
                                <i></i>
                                <span>{{$t('App.room.text26')}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="deviceLock_box" @click="deviceLock()">
                        <div class="deviceLock_bg" :class="{'unlock':lock == '1'}"></div>
                        <i class="iconfont icon-suoding" v-if="lock == '0'"></i>
                        <i class="iconfont icon-kaisuo" v-if="lock == '1'"></i>
                    </div>
                </div>
            </div>
        </div>

        <div class="centralizedSetting_wrap scrollbar_style" v-show="centralizedSettingTkShowbg">
            <div class="centralizedSetting_wrap_bg" @click="centralizedSettingTkClose()"></div>
            <div class="centralizedSetting_box" :class="{'centralizedSetting_tk_show':centralizedSettingTkShow}">
                <div class="centralizedSetting_title">
                    <span class="span1">{{$t('App.room.text27')}}</span>
                    <span class="span2" @click="centralizedSettingTkClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="form">
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text29')}}</span>
                        <el-dropdown @command="commandRoomFloor" trigger="click" @visible-change="commandHide('dropdown_room_floor')">
                            <span class="span1">{{roomFormFloorName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_room_floor">
                                <el-dropdown-item v-for="item in floorNav" :command="item" :key="'hotel_'+item.id" :class="{'select':item.id == roomForm.floorId}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text30')}}</span>
                        <el-dropdown @command="commandRoomRoom" trigger="click" @visible-change="commandHide('dropdown_room_room')">
                            <span class="span1">{{roomFormRoomName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_room_room">
                                <el-dropdown-item v-for="item in roomNav" :command="item" :key="'hotel_'+item.id" :class="{'select':item.id == roomForm.roomId}">{{item.number}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <!-- <el-input v-model="value4" placeholder="Please enter room number"></el-input> -->
                    </div>
                    <div class="form_item1">
                        <p class="p1">{{$t('App.room.text31')}}</p>
                        <p class="p2">{{roomForm.light}}%</p>
                        <el-slider v-model="roomForm.light" :step="2" :min="0" :max="100" class="slider1"></el-slider>
                    </div>
                    <div class="form_item1">
                        <p class="p1">{{$t('App.room.text32')}}</p>
                        <p class="p2">{{roomForm.color}}K</p>
                        <el-slider v-model="roomForm.color" :step="300" :min="3000" :max="6000" class="slider2"></el-slider>
                    </div>
                    <div class="form_item1">
                        <p class="p1">{{$t('App.room.text33')}}</p>
                        <color-picker :colorValueChange="colorValueChange" :colorChange="colorChange" ref="colorPicker"></color-picker>
                    </div>
                    <div class="form_item">
                        <div class="li_l">
                            <span>{{$t('App.room.text34')}}</span>
                        </div>
                        <div class="li_r">
                            <span class="pl_switch" :class="{'checked':roomForm.status == 1}" @click="plSwitchPurifierFun(roomForm.status)"></span>
                        </div>
                    </div>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="roomCmd">{{$t('App.room.text35')}}</div>
                </div>
            </div>
        </div>

        <div class="floorPlan_wrap scrollbar_style" v-show="floorPlanTkShowbg">
            <div class="floorPlan_wrap_bg" @click="floorPlanTkClose()"></div>
            <div class="floorPlan_box" :class="{'floorPlan_tk_show':floorPlanTkShow}">
                <div class="floorPlan_title">
                    <span class="span1">{{$t('App.room.text36')}} - {{floorName}}</span>
                    <span class="span2" @click="floorPlanTkClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="floorPlan_topNav">
                    <div class="li" :class="{'select':floorBGType == '0'}" @click="floorBGTypeFun('0')">Building</div>
                    <div class="li" :class="{'select':floorBGType == '1'}" @click="floorBGTypeFun('1')">Floor</div>
                </div>
                <div class="img_bg">
                    <img :src="floorBuildImageSrc" />
                </div>
            </div>
        </div>
        <div class="roomPlan_wrap scrollbar_style" v-show="roomPlanTkShowbg">
            <div class="roomPlan_wrap_bg" @click="roomPlanTkClose()"></div>
            <div class="roomPlan_box" :class="{'roomPlan_tk_show':roomPlanTkShow}">
                <div class="roomPlan_title">
                    <span class="span1">{{$t('App.room.text78')}}</span>
                    <span class="span2" @click="roomPlanTkClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="div">
                    <span class="span1" v-if="domainName != 'plant'">{{$t('App.room_light.text16')}}</span>
                    <span class="span1" v-if="domainName == 'plant'">{{$t('App.room_light.text16_')}}</span>
                    <el-dropdown @command="roomPlanCommand" trigger="click" @visible-change="commandHide('dropdown_room_plan')">
                        <span class="el-dropdown-link">
                            <span>{{roomPlanForm.plan_name}}</span>
                            <i class="el-icon-caret-bottom el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_room_plan">
                            <el-dropdown-item v-for="obj in roomPlanList" :command="obj" :key="obj.id" :class="{'select':roomPlanForm.plan_id==obj.id}">{{obj.cvsname}}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </div>
        <!-- map添加设备 -->
        <div class="mapDevice scrollbar_style" v-show="mapDeviceTkShowbg">
            <div class="mapDevice_bg" :style="{'min-height':(mapDeviceForm.list.length*10+35)+'rem'}" @click="mapDeviceTkClose()"></div>
            <div class="mapDevice_box" :style="{'min-height':(mapDeviceForm.list.length*10+35)+'rem'}" :class="{'mapDevice_tk_show':mapDeviceTkShow}">
                <div class="mapDevice_title">
                    <span class="span1">{{$t('App.room.text8')}}</span>
                    <span class="span2" @click="mapDeviceTkClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="form">
                    <div class="mapDeviceForm_box" v-for="(obj,index) in mapDeviceForm.list" :key="'mapDeviceForm_box_'+index">
                        <div class="form_item">
                            <span class="laber">{{$t('App.room.text37')}}</span>
                            <el-dropdown @command="commandMapDeviceType" trigger="click" @visible-change="commandHide('dropdown_map_devicetype')">
                                <span class="span1">{{obj.name}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                                <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_map_devicetype">
                                    <el-dropdown-item v-for="item in mapDeviceTypeList" :command="{data:item,index:index}" :key="'hotel_'+item.id" :class="{'select':item.id == obj.type}">{{item.name}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                        <div class="form_item">
                            <span class="laber">{{$t('App.room.text38')}}</span>
                            <el-input v-model="obj.deviceCount" placeholder=""></el-input>
                        </div>
                    </div>
                    <div class="dashed"></div>
                    <div class="btn" @click="addMapDevice()">{{$t('App.room.text75')}}</div>
                    <div class="form_item arrangement">
                        <span class="laber">{{$t('App.room.text39')}}</span>
                        <el-dropdown @command="commandMapArrangement" trigger="click" @visible-change="commandHide('dropdown_map_devicetype')">
                            <span class="span1">{{mapArrangementName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_map_devicetype">
                                <el-dropdown-item v-for="item in mapArrangementList" :command="item" :key="'hotel_'+item.id" :class="{'select':item.id == mapDeviceForm.layoutType}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item" v-if="mapDeviceForm.layoutType == '1'||mapDeviceForm.layoutType == '2'">
                        <span class="laber">{{$t('App.room.text40')}}</span>
                        <el-input v-model="mapDeviceForm.space" type="number" min="0" placeholder="" class="number"></el-input>
                    </div>
                    <div class="form_item" v-if="mapDeviceForm.layoutType == '2'">
                        <span class="laber">{{$t('App.room.text41')}}</span>
                        <el-input v-model="mapDeviceForm.columnNumber" type="number" min="0" placeholder=""></el-input>
                    </div>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="setPlaneLayoutInfo()">{{$t('App.room.text35')}}</div>
                </div>
            </div>
        </div>
        <!-- map编辑设备 -->
        <div class="mapEditDevice scrollbar_style" v-show="mapEditDeviceTkShowbg" ref="mapEditDevice">
            <div class="mapEditDevice_bg" @click="mapEditDeviceTkClose()"></div>
            <div class="mapEditDevice_box" :class="{'mapEditDevice_tk_show':mapEditDeviceTkShow}">
                <div class="mapEditDevice_title">
                    <span class="span1">{{$t('App.lights.text37')}}</span>
                    <span class="span2" @click="mapEditDeviceTkClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="form">
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text18')}}</span>
                        <el-input v-model="mapEditDeviceForm.devId" placeholder="" disabled></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text42')}}</span>
                        <el-input v-model="mapEditDeviceForm.name" placeholder=""></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text43')}}</span>
                        <el-input v-model="mapEditDeviceForm.address" placeholder=""></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text74')}}</span>
                        <el-input v-model="mapEditDeviceForm.gatewayId" placeholder=""></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text29')}}</span>
                        <el-dropdown @command="commandDeviceFloor" trigger="click" @visible-change="commandHide('dropdown_device_floor')">
                            <span class="span1">{{mapEditDeviceFormFloorName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_device_floor">
                                <el-dropdown-item v-for="item in floorNav" :command="item" :key="'hotel_'+item.id" :class="{'select':item.id == mapEditDeviceForm.floorId}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text30')}}</span>
                        <el-dropdown @command="commandDeviceRoom" trigger="click" @visible-change="commandHide('dropdown_device_room')">
                            <span class="span1">{{mapEditDeviceFormRoomName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_device_room">
                                <el-dropdown-item v-for="item in roomNav" :command="item" :key="'hotel_'+item.id" :class="{'select':item.id == mapEditDeviceForm.roomId}">{{item.number}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <!-- <div class="form_item">
                        <span class="laber">{{$t('App.room.text44')}}</span>
                        <el-input v-model="mapEditDeviceForm.number" placeholder=""></el-input>
                    </div> -->
                </div>
                <div class="btn_box">
                    <div class="btn" @click="updateDevInfo()">{{$t('App.room.text35')}}</div>
                </div>
            </div>
        </div>
        <!-- map上传背景图 -->
        <div class="map_floorplan_wrap scrollbar_style" v-show="floorplanShowBg">
            <div class="map_floorplan_wrap_bg" @click="floorplanTkClose()"></div>
            <div class="tk_box" :class="{'tk_show':floorplanShow}">
                <div class="tk_title">
                    <span class="span1">{{$t('App.room.text7')}}</span>
                    <span class="span2" @click="floorplanTkClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="form">
                    <div class="tabs">
                        <span class="span1">!</span><span class="span2">{{$t('App.room.text45')}}</span>
                    </div>
                    <el-upload
                        class="avatar-uploader"
                        :show-file-list="false"
                        name="file"
                        :data="imgUploadData"
                        :action="actionImgUrl"
                        :on-progress="hotelLogoProgress"
                        :on-change="hotelLogoChange"
                        :on-success="hotelLogoSuccess"
                        :before-upload="beforeAvatarUpload">
                        <span><i class="iconfont icon-shangchuan"></i><span>{{$t('App.room.text46')}}</span></span>
                    </el-upload>
                    <div class="upload_progress" v-if="uploadHotelLogoStatus == '1'">
                        <div class="l">
                            <div class="i_box">
                                <i class="el-icon-link"></i>
                            </div>
                            <div class="text">
                                {{$t('App.room.text47')}}
                            </div>
                            <el-progress :percentage="uploadHotelLogoSlider" :show-text="false"></el-progress>
                        </div>
                        <div>{{uploadHotelLogoSlider}}%</div>
                    </div>
                    <div class="success" v-if="uploadHotelLogoStatus == '2'">
                        <div class="box">
                            <div class="l">
                                <div class="i_box">
                                    <img src="../img/room/map/img_icon.png">
                                </div>
                                <div class="text1">{{$t('App.room.text48')}}</div>
                                <div class="text2" :title="hotelLogoName">{{hotelLogoName}}</div>
                                <div class="text3">{{hotelLogoSize}}kb</div>
                            </div>
                        </div>
                        <div class="logo_box">
                            <img :src="hotelLogo">
                        </div>
                    </div>
                    <div class="error" v-if="uploadHotelLogoStatus == '3'">
                        <div class="box">
                            <div class="l">
                                <div class="i_box">
                                    <i class="el-icon-link"></i>
                                </div>
                                <div class="text1">{{hotelLogoName}}</div>
                            </div>
                            <div class="r"><i class="el-icon-close"></i><span>{{$t('App.room.text49')}}</span></div>
                        </div>
                        <div class="logo_box">
                            <img :src="hotelLogo">
                        </div>
                    </div>
                    <div class="dashed"></div>
                    <div class="item_title">
                        <div class="div"><i></i></div><div class="span">{{$t('App.room.text50')}}</div>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text29')}}</span>
                        <el-dropdown @command="commandFloorplanFloor" trigger="click" @visible-change="commandHide('dropdown_floorplan_floor')">
                            <span class="span1">{{floorplanFormFloorName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_floorplan_floor">
                                <el-dropdown-item v-for="item in floorNav" :command="item" :key="'hotel_'+item.id" :class="{'select':item.id == floorplanForm.floorId}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="setLayoutImage()">{{$t('App.room.text35')}}</div>
                </div>
            </div>
        </div>
        <!-- 绑定 -->
        <div class="map_binding_wrap scrollbar_style" v-show="bindingShowBg">
            <div class="map_binding_wrap_bg" @click="bindingTkClose()"></div>
            <div class="tk_box" :class="{'tk_show':bindingShow}">
                <div class="tk_title">
                    <span class="span1">{{$t('App.room.text51')}}</span>
                    <span class="span2" @click="bindingTkClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="switch_box">
                    <div class="div" :class="{'select':mapBindingType == '1'}" @click="mapBindingTypeFun('1')">{{$t('App.room.text52')}}</div>
                    <div class="div" :class="{'select':mapBindingType == '2'}" @click="mapBindingTypeFun('2')">{{$t('App.room.text53')}}</div>
                </div>
                <div class="form" v-if="mapBindingType == '1'" key="mapBindingType_1">
                    <div class="tabs1">
                        <span class="span1">{{$t('App.room.text54')}}</span><span class="span2" :class="{'select':allDevSelect == '1'}" @click="mapNewAllDevSelect()"><i class="el-icon-check"></i></span>
                    </div>
                    <div class="ul scrollbar_style">
                        <div class="li" v-for="item in mapNewDevList" :key="item.type+'_'+item.id">
                            <div class="l">
                                <div class="img_box">
                                    <div class="img" :class="'img_'+item.type" >
                                        <img :src="require('../img/room/map/lights_'+item.type+(version=='1'?'_v1':'')+'.png')">
                                    </div>
                                </div>
                                <div class="text_box">
                                    <p class="p1">{{mapDeviceTypeList[item.type].name}}</p>
                                    <p class="p2"><span class="span2">ID{{item.id}}</span></p>
                                </div>
                            </div>
                            <div class="r">
                                <div class="btn" :class="{'select':item.select == '1'}" @click="mapNewDevSelect(item)"><i class="el-icon-check"></i></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form" v-if="mapBindingType == '2'" key="mapBindingType_2">
                    <div class="box">
                        <div class="tabs2">
                            <span class="span1">!</span><span class="span2">{{$t('App.room.text55')}}</span>
                        </div>
                        <el-upload
                            class="avatar-uploader"
                            :show-file-list="false"
                            name="file"
                            :data="excelUploadData"
                            :action="actionExcelUrl"
                            :on-progress="hotelLogoProgress"
                            :on-change="excelChange"
                            :on-success="hotelLogoSuccess"
                            :before-upload="beforeUploadExcel">
                            <span><i class="iconfont icon-shangchuan"></i><span>{{$t('App.room.text56')}}</span></span>
                        </el-upload>
                        <div class="upload_progress" v-if="uploadHotelLogoStatus == '1'">
                            <div class="l">
                                <div class="i_box">
                                    <i class="el-icon-link"></i>
                                </div>
                                <div class="text">
                                    {{$t('App.room.text47')}}
                                </div>
                                <el-progress :percentage="uploadHotelLogoSlider" :show-text="false"></el-progress>
                            </div>
                            <div>{{uploadHotelLogoSlider}}%</div>
                        </div>
                        <div v-if="excelUploadData.type == '2'" style="height:calc(100% - 13rem)">
                            <div v-if="tableDataBatchError.length>0" style="height:100%">
                                <p class="error_title">
                                  <i class="el-icon-error"></i> <span>{{$t('App.room.text57')}}</span>
                                </p>
                                <p class="error_box scrollbar_style">
                                  <span v-for="(item,index) in tableDataBatchError" :key="'tableDataBatchError_'+index">{{item}}</span>
                                </p>
                            </div>
                            <div v-if="tableDataBatchError.length == 0" style="height:100%">
                                <p class="verify_success">{{$t('App.room.text58')}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="getInputExcel()" v-if="mapBindingType == '1'">{{$t('App.room.text59')}}</div>
                    <div class="btn" @click="batchInput()" v-if="mapBindingType == '2'&&excelUploadData.type == '2'&&tableDataBatchError.length == 0">{{$t('App.room.text60')}}</div>
                </div>
            </div>
        </div>
        <el-dialog
          :title="$t('App.room.text61')"
          :visible.sync="confirmUserShow"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          class="confirm_user"
          width="50rem">
          <el-form ref="confirmUserForm" :model="confirmUserForm" label-width="9rem">
            <el-form-item :label="$t('App.room.text62')" >
                <el-input 
                  v-model="confirmUserForm.name" maxlength="6" @keyup.native="userAuthenticationKeyUp($event)">
                </el-input>
            </el-form-item>
            <el-form-item :label="$t('App.room.text63')" >
                <el-input 
                  show-password
                  v-model="confirmUserForm.password" maxlength="6" @keyup.native="userAuthenticationKeyUp($event)">
                </el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="userAuthentication()">{{$t('App.room.text64')}}</el-button>
          </span>
        </el-dialog>
        <button type="button" id="btn2" style="display: none"></button>
    </div>
</template>

<script type="text/javascript">
    import colorPicker from '../components/colorPicker'
    // import sideBar from '../components/sideBar.vue'
    import allUrl from '../api/allUrl.js'
    import base from '../api/base.js'
    import { mapGetters } from 'vuex'
    export default {
        name:'room',
        data () {
            return{
                confirmUserShow:false,
                confirmUserForm:{
                    name:'',
                    password:'',
                },

                keywords:'',
                buildId:'',
                buildName:'',
                buildNav:[],
                floorRoomList:[],
                roomList:[],
                floorId:'',
                floorName:'',
                floorIndex:0,
                floorNav:[],
                sensorStatusArr:['Off-line','On-line'],
                purifierStatus:['Off','Low','Middle','High'],
                roomRightMainLB:0,
                floorBGType:'0',
                roomForm:{
                    floorId:'',
                    roomId:'',
                    light:0,
                    color:0,
                    colorR:'',
                    colorG:'',
                    colorB:'',
                    status:1,
                    level:1,
                },
                roomNav:[],
                floorBuildImage:{
                    buildImage:'',
                    floorImage:'',
                },
                classificationColorArr2:['#05CFAB','#FEBF00','#FFF100'],

                roomType:'1',

                mapDevList:[],
                dragType:'',
                buttonType:'',
                dragDeviceId:'',
                planeLayoutDevInfo:{},

                svpanelTop:0,
                svpanelLeft:0,
                offsetX:0,
                offsetY:0,
                clientWidth:0,
                clientHeight:0,
                mapBgWidth:0,
                mapBgHeight:0,

                moveLeft:0,
                moveTop:0,
                clickLocationX:'',
                clickLocationY:'',

                frameSelectionTop:0,
                frameSelectionLeft:0,
                frameSelectionTop_:0,
                frameSelectionLeft_:0,
                frameSelectionWidth:0,
                frameSelectionHeight:0,
                frameSelectionShow:false,
                frameSelectionIsShow:false,
                isSave:false,
                isSaveTime:null,

                rightClickMenuTop:0,
                rightClickMenuLeft:0,
                rightClickMenuShow:false,
                rightClickMenuType:1,
                rightClickMenuDevId:null,
                rightClickMenu_copy_Show:false,
                rightClickMenu_paste_Show:false,
                rightClickMenu_delete_Show:false,
                mapDeviceCopyList:[],

                clickMenuMoveTop:0,
                clickMenuMoveLeft:0,
                clickMenuMoveHeight:0,
                clickMenuMoveWidth:0,
                clickMenuMoveShow:false,

                mapDevicePasteIsTrue:false,

                deviceLockTitle:'Lock',
                lock:'0',
                lockTitleShow:false,
                lockTitleShowTime:null,

                /*map设备弹框*/
                mapDeviceTkShow:false,
                mapDeviceTkShowbg:false,
                mapDeviceTypeList:[{name:'Lights',id:'0'},{name:'Circadian lights',id:'1'},{name:'Sensor',id:'2'},{name:'Air purifiers',id:'3'}],
                mapArrangementList:[{name:'Coincidence',id:'0'},{name:'Equidistant',id:'1'},{name:'Matrix',id:'2'}],
                mapDeviceForm:{
                    list:[{type:'0',deviceCount:'',name:'Lights'}],
                    layoutType:'0',
                    columnNumber:'',
                    width:'',
                    space:'',
                },
                /*编辑设备弹框*/
                mapEditDeviceTkShowbg:false,
                mapEditDeviceTkShow:false,
                mapEditDeviceForm:{
                    devId:'',
                    floorId:'',
                    roomId:'',
                    address:'',
                    type:'',
                    number:'',
                    name:'',
                    gatewayId:'',
                },

                deviceInfo:{
                    name:'',
                    id:'',
                    number:'',
                    locationX:'',
                    locationY:'',
                    status:'',
                    light:'',
                    color:'',
                    type:'0',
                    deviceId:'',
                    roomId:'',
                    roomNumber:'',
                },
                deviceInfoUpdate:true,

                deviceTipsShow:false,

                floorplanShowBg:false,
                floorplanShow:false,
                imgUploadData:{
                    username:'',
                    client_key:'',
                    token:'',
                },
                actionImgUrl:'',
                hotelLogo:'',
                uploadHotelLogoSlider:0,
                uploadHotelLogoStatus:'0',
                hotelLogoName:'',
                hotelLogoSize:0,
                floorplanForm:{
                    floorId:'',
                },
                layoutImage:'',

                bindingShowBg:false,
                bindingShow:false,
                mapBindingType:'1',
                allDevSelect:'0',
                mapNewDevList:[],
                actionExcelUrl:'',
                excelUploadData:{
                    username:'',
                    client_key:'',
                    token:'',
                    type:'',
                },
                tbleDataBatch:[],
                tableDataBatchError:[],

                centralizedSettingTkShowbg:false,
                centralizedSettingTkShow:false,

                value5:0,
                value6:0,
                openArr:['One-level','Two-level'],

                floorPlanTkShowbg:false,
                floorPlanTkShow:false,
                floorBuildImageSrc:'',
                loading:{
                    tbleDataBatch:false,
                    roomList:false,
                },
                imgErrorSrc:'',
                bindingTkOpenShow:false,

                img_lights_0:'',
                img_lights_1:'',
                img_lights_2:'',
                img_lights_3:'',
                img_bindingTkOpen:'',

                roomPlanTkShowbg:false,
                roomPlanTkShow:false,
                roomPlanForm:{
                    id:'',
                    plan_id:'',
                    plan_name:'',
                },
                roomPlanList:[],
            }
        },
        computed:{
            ...mapGetters({
                token:'token',
                client_key:'client_key',
                username:'username',
                version:'version',

                countryId:'countryId',
                provinceId:'provinceId',
                cityId:'cityId',
                hotelId:'hotelId',
                headerIdStr:'headerIdStr',

                remRatio:'remRatio',
                hotelType:'hotelType',
                domainName:'domainName',
            }),
            roomFormFloorName() {
                let name = '';
                for(let d of this.floorNav){
                    if(d.id == this.roomForm.floorId){
                        name = d.name;
                    }
                }
                return name;
            },
            roomFormRoomName() {
                let name = '';
                for(let d of this.roomNav){
                    if(d.id == this.roomForm.roomId){
                        name = d.number;
                    }
                }
                return name;
            },
            mapArrangementName() {
                let name = '';
                for(let d of this.mapArrangementList){
                    if(d.id == this.mapDeviceForm.layoutType){
                        name = d.name;
                    }
                }
                return name;
            },
            mapEditDeviceFormFloorName() {
                let name = '';
                for(let d of this.floorNav){
                    if(d.id == this.mapEditDeviceForm.floorId){
                        name = d.name;
                    }
                }
                return name;
            },
            mapEditDeviceFormRoomName() {
                let name = '';
                for(let d of this.roomNav){
                    if(d.id == this.mapEditDeviceForm.roomId){
                        name = d.number;
                    }
                }
                return name;
            },
            floorplanFormFloorName() {
                let name = '';
                for(let d of this.floorNav){
                    if(d.id == this.floorplanForm.floorId){
                        name = d.name;
                    }
                }
                return name;
            },
        },
        components:{
            // 'sideBar':sideBar,
            'colorPicker':colorPicker
        },
        mounted(){
            this.img_lights_0 = require('../img/room/map/lights_0.png');
            this.img_lights_1 = require('../img/room/map/lights_1.png');
            this.img_lights_2 = require('../img/room/map/lights_2.png');
            this.img_lights_3 = require('../img/room/map/lights_3.png');
            this.img_bindingTkOpen = require('../img/bindingTkOpen.png')

            if(this.version == '1'){
                this.img_lights_0 = require('../img/room/map/lights_0_v1.png');
                this.img_lights_1 = require('../img/room/map/lights_1_v1.png');
                this.img_lights_2 = require('../img/room/map/lights_2_v1.png');
                this.img_lights_3 = require('../img/room/map/lights_3_v1.png');
                this.img_bindingTkOpen = require('../img/bindingTkOpen_v1.png');
            }

            this.sensorStatusArr = [this.$t('App.room.text65'),this.$t('App.room.text66')];
            this.purifierStatus = [this.$t('App.room.text67'),this.$t('App.room.text68'),this.$t('App.room.text69'),this.$t('App.room.text70')];

            if(this.domainName == 'plant') {
                this.mapDeviceTypeList = [{name:this.$t('App.dashboard.text32'),id:'0'},{name:this.$t('App.sideBar.text24'),id:'1'},{name:this.$t('App.dashboard.text34'),id:'2'},{name:this.$t('App.dashboard.text35'),id:'3'},{name:this.$t('App.sideBar.text3'),id:'4'},{name:this.$t('App.sideBar.text4'),id:'5'},{name:this.$t('App.sideBar.text5'),id:'6'},{name:this.$t('App.sideBar.text6'),id:'7'}];
            } else {
                this.mapDeviceTypeList = [{name:this.$t('App.dashboard.text32'),id:'0'},{name:this.$t('App.dashboard.text33'),id:'1'},{name:this.$t('App.dashboard.text34'),id:'2'},{name:this.$t('App.dashboard.text35'),id:'3'},{name:this.$t('App.sideBar.text3'),id:'4'},{name:this.$t('App.sideBar.text4'),id:'5'},{name:this.$t('App.sideBar.text5'),id:'6'},{name:this.$t('App.sideBar.text6'),id:'7'}];
            }
            this.mapArrangementList = [{name:this.$t('App.room.text71'),id:'0'},{name:this.$t('App.room.text72'),id:'1'},{name:this.$t('App.room.text73'),id:'2'}];
            this.mapDeviceForm.list = [{type:'0',deviceCount:'',name:this.$t('App.dashboard.text32')}];

            let this_ = this;
            this.imgErrorSrc = 'this.src="' + require('../img/room/room_mr.png') + '"';
            this.imgUploadData.username = this.username;
            this.imgUploadData.client_key = this.client_key;
            this.imgUploadData.token = this.token;
            this.actionImgUrl = allUrl.userManagement.updateFile;

            this.excelUploadData.username = this.username;
            this.excelUploadData.client_key = this.client_key;
            this.excelUploadData.token = this.token;
            this.excelUploadData.type = '1';
            this.actionExcelUrl = allUrl.room.batchInput;

            this.$store.commit('SIDEBARSHOW',{
                sideBarShow:true,
            });
            var storage = window.localStorage;
            if(this.hotelId){
                this.getbuildNav(()=>{
                    if(this.buildNav.length > 0){
                        if(storage.getItem('buildIdNav')){
                            let isbuildId = true;
                            for(let d of this.buildNav){
                                    console.log(d.id,'----')
                                if(d.id == storage.getItem('buildIdNav')){
                                    this.buildId = d.id;
                                    isbuildId = false;
                                }
                            }
                            if(isbuildId){
                                this.buildId = this.buildNav[0].id;
                            }
                        }else{
                            this.buildId = this.buildNav[0].id;
                        }
                        this.getroomList('',()=>{
                            if(this.floorRoomList.length > 0){
                                this.floorId = this.floorRoomList[0].id;
                                this.floorName = this.floorRoomList[0].name;
                                this.roomList = this.floorRoomList[0].roomList;
                                this.floorIndex = 1;

                                if(this.roomType == '2'){
                                    this.getPlaneLayoutInfo('0');
                                    this.getPlaneLayoutDevInfo();
                                    this.getLayoutImage();
                                }
                            }
                        })
                    }else{
                        this.roomList = [];
                    }
                });
            }

            base.websocket(allUrl.websocket.ws,websocket=>{
                this.websocket2 = websocket;
                websocket.send('{"type":"cmd"}');
                websocket.onmessage = event => {
                    console.log(JSON.parse(event.data),'------');
                    let data = JSON.parse(event.data)
                    if(data.code == '0000'){
                        if(data.data.status == '1'){
                            this.clientid = data.data.clientid
                        }
                        if(data.data.status == '2'){
                            if(data.data.type == 'lamp_cmd'){
                                this.$message({
                                  showClose: true,
                                  message: data.msg,
                                  type: 'success'
                                });
                                this.centralizedSettingTkShow = false;
                                setTimeout(function(){
                                    this_.centralizedSettingTkShowbg = false;
                                },800)
                            }
                        }
                    }else{
                        this.$alert(data.msg, this.$t('App.message.text1'), {
                            confirmButtonText: this.$t('App.message.text2'),
                        });
                        // if(data.data.status == '2'){
                        //     if(data.data.type == 'lamp_cmd'){
                        //         for(let d of this.deviceList){
                        //             if(d.id == this.lightId){
                        //                 d.status = this.status_;
                        //             }
                        //         }
                        //     }
                        // }
                    }
                }
            },this)
            this.getPlan();
        },
        methods:{
            openRoomPlan(data){
                this.roomPlanTkShowbg = true;
                this.$nextTick(function(){
                    this.roomPlanTkShow = true;
                })
                this.roomPlanForm.roomId = data.id;
                this.roomPlanForm.plan_id = data.plan_id;
                this.roomPlanForm.plan_name = data.plan_name;
            },
            roomPlanTkClose(){
                let this_ = this;
                this.roomPlanTkShow = false;
                setTimeout(function(){
                    this_.roomPlanTkShowbg = false;
                },800)
            },
            getPlan(){
                base.ajax_post(
                    allUrl.roomLight.plan,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                    },
                    {},
                    data=>{
                        this.roomPlanList = data.data;
                    },
                    this
                )
            },
            roomPlanCommand(obj){
                // this.cirLightsPlanId = data.id;
                // this.cirLightsPlanName = data.cvsname;
                // let item =data.item;
                // let obj =data.obj;
                // console.log(data,item,obj)
                // item.plan_id = obj.id;
                // item.plan_name = obj.cvsname;
                // this.roomPlanForm.cvsname = data.cvsname;
                this.roomPlanForm.plan_id = obj.id;
                this.roomPlanForm.plan_name = obj.cvsname;
                base.ajax_post(
                    allUrl.room.set_room_plan,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        roomId:this.roomPlanForm.roomId,
                        plan_id:obj.id,
                    },
                    {},
                    data=>{
                        this.$message({
                          showClose: true,
                          message: data.msg,
                          type: 'success'
                        });
                    },
                    this
                )
            },
            plSwitchPurifierFun(){
                if(this.roomForm.status == 1){
                    this.roomForm.status = 0;
                }else{
                    this.roomForm.status = 1;
                }
            },
            levelCommand(arr){
                this.roomForm.level = arr[1];
            },
            mapNewAllDevSelect(){
                if(this.allDevSelect == '0'){
                    this.allDevSelect = '1'
                    for(let d of this.mapNewDevList){
                        d.select = '1'
                    }
                }else{
                    this.allDevSelect = '0'
                    for(let d of this.mapNewDevList){
                        d.select = '0'
                    }
                }
            },
            mapNewDevSelect(data){
                if(data.select == '1'){
                    data.select = '0'
                }else{
                    data.select = '1'
                }
            },
            deviceLock(){
                if(this.lock == '1'){
                    this.deviceLockTitle = 'Lock';
                    this.lock = '0'
                    this.clickMenuMoveShow = false;
                }else{
                    this.confirmUserShow = true;
                }
            },
            userAuthenticationKeyUp(e,type){
                if(e.key == 'Enter'){
                  this.userAuthentication(type);
                }
            },
            userAuthentication(){
                base.ajax_post(
                    allUrl.room.userAuthentication,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        name:this.confirmUserForm.name,
                        password:this.confirmUserForm.password,
                    },
                    {},
                    data=>{
                        this.$message({
                          showClose: true,
                          message: data.msg,
                          type: 'success'
                        });
                        this.confirmUserShow = false;
                        this.deviceLockTitle = 'Unlock';
                        this.lock = '1'
                        this.clickMenuMoveShow = true;

                        this.clickMenuMoveHeight = this.remRatio*7.5;
                        this.clickMenuMoveWidth = this.remRatio*9;

                        this.clickMenuMoveLeft = this.mapBgWidth - this.clickMenuMoveWidth;
                        this.clickMenuMoveTop = this.mapBgHeight/2 - this.clickMenuMoveHeight/2;
                    },
                    this,
                )
            },
            bindingTkOpen(){
                this.bindingShowBg = true;
                this.$nextTick(function(){
                    this.bindingShow = true;
                })
                this.getPlaneLayoutInfo('1',data=>{
                    // console.log(data)
                    this.mapNewDevList = data.data.devList;
                    for(let d of this.mapNewDevList){
                        this.$set(d,'select','0')
                    }
                });
                this.excelUploadData.floorId = this.floorId;
            },
            getInputExcel(){
                // let this_ = this;
                let devList = [];
                for(let d of this.mapNewDevList){
                    if(d.select == '1'){
                        devList.push(d)
                    }
                }
                base.ajax_post(
                    allUrl.room.getInputExcel,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        floorId:this.floorId,
                        devList:devList,
                    },
                    {},
                    data=>{
                        var $eleForm = $("<form method='get'></form>");
                        $eleForm.attr("action",data.data.path);
                        $(document.body).append($eleForm);
                        //提交表单，实现下载
                        $eleForm.submit();
                        // this.getPlaneLayoutInfo();
                        // this.getPlaneLayoutDevInfo();
                        // this.bindingShow = false;
                        // setTimeout(function(){
                        //     this_.bindingShowBg = false;
                        // },800)
                    },
                    this
                )
            },
            bindingTkClose(){
                let this_ = this;
                this.bindingShow = false;
                setTimeout(function(){
                    this_.bindingShowBg = false;
                },800)
            },
            mapBindingTypeFun(val){
                this.mapBindingType = val;
                if(val == '2'){
                    this.excelUploadData.type = '1';
                    this.tbleDataBatch = [];
                    this.tableDataBatchError = [];
                }
            },
            beforeUploadExcel() {
                // this.excelUploadData.type = '2';
                // return
            },
            excelChange(res,file){
                console.log(res,file)
                let this_ = this;
                this.hotelLogoName = res.name;
                this.hotelLogoSize = res.size/1000;
                if(res.status == 'success'){
                    if(res.response.code == '0000'){
                        this.excelUploadData.type = '2';
                        this.uploadHotelLogoStatus = '2';

                        this.tbleDataBatch = res.response.data.devList;
                        let i = 1;
                        for(let d of this.tbleDataBatch){
                            d.GL_index = i;
                            i++;
                        }
                        this.tableDataBatchError = res.response.data.msg;
                    }else{
                        this.$alert(res.response.msg, this.$t('App.message.text1'), {
                            confirmButtonText: this.$t('App.message.text2'),
                        });
                        this.uploadHotelLogoStatus = '3';
                    }
                }else if(res.status== 'ready'){
                    this_.uploadHotelLogoStatus = '0';
                }else{
                    this_.uploadHotelLogoStatus = '3';
                }
            },
            batchInput(){
                base.ajax_post(
                    allUrl.room.batchInput,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        floorId:this.floorId,
                        type:2,
                        devList:this.tbleDataBatch,
                    },
                    {},
                    data =>{
                        this.$message({
                            showClose: true,
                            message: data.msg,
                            type: 'success'
                        });
                        this.getPlaneLayoutInfo('0');
                        this.getPlaneLayoutDevInfo();
                        let this_ = this;
                        this.bindingShow = false;
                        setTimeout(function(){
                            this_.bindingShowBg = false;
                        },800)
                    },
                this)
            },

            floorplanTkOpen(){
                let this_ = this;
                this.floorplanShowBg = true;
                this.$nextTick(function(){
                    this_.floorplanShow = true;
                })
                this.getfloorNav(()=>{
                    if(this.floorNav.length>0){
                        this.floorplanForm.floorId = this.floorId;
                    }
                })
                this.uploadHotelLogoStatus = '0';
                this.uploadHotelLogoSlider = 0;
                this.hotelLogo = '';
                this.hotelLogoName = '';
                this.hotelLogoSize = 0;
            },
            commandFloorplanFloor(data){
                this.floorplanForm.floorId = data.id;
            },
            hotelLogoSuccess(res){
                console.log(res)
                // this.hotelLogo = res.data.path;
            },
            hotelLogoChange(res,file){
                console.log(res,file)
                let this_ = this;
                this.hotelLogoName = res.name;
                this.hotelLogoSize = res.size/1000;
                if(res.status == 'success'){
                    if(res.response.code == '0000'){
                        this.hotelLogo = res.response.data.path;
                        this.uploadHotelLogoStatus = '2';
                    }else{
                        this.$alert(res.response.data.error, this.$t('App.message.text1'), {
                            confirmButtonText: this.$t('App.message.text2'),
                        });
                        this.uploadHotelLogoStatus = '3';
                    }
                }else if(res.status== 'ready'){
                    this_.uploadHotelLogoStatus = '0';
                }else{
                    this_.uploadHotelLogoStatus = '3';
                }
            },
            hotelLogoProgress(event){
                this.uploadHotelLogoStatus = '1';
                this.uploadHotelLogoSlider = parseInt(event.percent);
            },
            beforeAvatarUpload() {
                // console.log(file.type)
                // const isJPG = file.type === 'image/jpeg';
                // const isPNG = file.type === 'image/png';
                // const isLt2M = file.size / 1024 / 1024 < 2;

                // if (!isJPG&&!isPNG) {
                //     this.$message.error('上传头像图片只能是 JPG、PNG 格式!');
                // }
                // if (!isLt2M) {
                //     this.$message.error('上传头像图片大小不能超过 2MB!');
                // }
                // return (isJPG||isPNG) && isLt2M;
                return true;
            },
            floorplanTkClose(){
                let this_ = this;
                this.floorplanShow = false;
                setTimeout(function(){
                    this_.floorplanShowBg = false;
                },800)
            },
            /*楼层绑定平面图*/
            setLayoutImage(){
                base.ajax_post(
                    allUrl.room.setLayoutImage,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        floorId:this.floorId,
                        // buildId:
                        image:this.hotelLogo,
                    },
                    {},
                    data=>{
                        this.$message({
                          showClose: true,
                          message: data.msg,
                          type: 'success'
                        });
                        let this_ = this;
                        this.floorplanShow = false;
                        setTimeout(function(){
                            this_.floorplanShowBg = false;
                        },800)
                        this.getLayoutImage();
                    },
                    this
                )
            },
            /*获取楼层平面图*/
            getLayoutImage(){
                if(this.floorId){
                    base.ajax_post(
                        allUrl.room.getLayoutImage,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            floorId:this.floorId,
                        },
                        {},
                        data=>{
                            this.layoutImage = data.data.image;
                        },
                        this
                    )
                }
            },
            /*获取平面布局信息*/
            getPlaneLayoutInfo(type,callback){
                if(this.floorId){
                    if(type == '0'){
                        this.loading.mapDevList = true;
                    }
                    base.ajax_post(
                        allUrl.room.getPlaneLayoutInfo,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            floorId:this.floorId,
                            type:type,
                        },
                        {},
                        data=>{
                            if(type == '0'){
                                // const container = this.$refs.planebaseMap
                                // const rect = container.getBoundingClientRect();
                                this.loading.mapDevList = false;
                                this.mapDevList = data.data.devList;
                                this.bindingTkOpenShow = false;
                                for(let d of this.mapDevList){
                                    d.locationX = d.locationX<0?0:d.locationX;
                                    d.locationX = d.locationX>97?97:d.locationX;

                                    d.locationY = d.locationY<0?0:d.locationY;
                                    d.locationY = d.locationY>(100-3/(this.mapBgHeight/this.mapBgWidth).toFixed(4))?(100-3/(this.mapBgHeight/this.mapBgWidth).toFixed(4)):d.locationY;
                                    
                                    d.x1 = (d.locationX*this.mapBgWidth/100).toFixed(4);
                                    d.y1 = (d.locationY*this.mapBgHeight/100).toFixed(4);
                                    d.x2 = (d.locationX*this.mapBgWidth/100+Number(this.clientWidth.toFixed(4))).toFixed(4);
                                    d.y2 = (d.locationY*this.mapBgHeight/100+Number(this.clientHeight.toFixed(4))).toFixed(4);
                                    this.$set(d,'frameSelection',0);
                                    d.locationX = d.locationX+'%';
                                    d.locationY = d.locationY+'%';
                                    // if(d.type == '2'){
                                        this.$set(d,'status',d.online?d.online:'0')
                                    // }
                                    if(!d.deviceId){
                                        d.status = 'new'
                                        this.bindingTkOpenShow = true;
                                    }
                                }
                            }
                            if(callback){
                                callback(data)
                            }
                        },
                        this,()=>{
                            this.loading.mapDevList = false;
                        }
                    )
                }
            },
            getPlaneLayoutDevInfo(callback){
                if(this.floorId){
                    base.ajax_post(
                        allUrl.room.getPlaneLayoutDevInfo,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            floorId:this.floorId,
                        },
                        {},
                        data=>{
                            this.planeLayoutDevInfo = data.data;
                            if(callback){
                                callback(data)
                            }
                        },
                        this
                    )
                }
            },
            /*批量添加设备*/
            setPlaneLayoutInfo(){
                base.ajax_post(
                    allUrl.room.setPlaneLayoutInfo,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        floorId:this.floorId,
                        devList:this.mapDeviceForm.list,
                        layoutType:this.mapDeviceForm.layoutType,
                        columnNumber:this.mapDeviceForm.columnNumber,
                        space:this.mapDeviceForm.space != 0?this.mapDeviceForm.space/10:0,
                        width:3,
                        proportion:(this.mapBgHeight/this.mapBgWidth).toFixed(4),
                    },
                    {},
                    data=>{
                        this.$message({
                          showClose: true,
                          message: data.msg,
                          type: 'success'
                        });
                        let this_ = this;
                        this.mapDeviceTkShow = false;
                        setTimeout(function(){
                            this_.mapDeviceTkShowbg = false;
                        },800)
                        this.getPlaneLayoutInfo('0');
                        this.getPlaneLayoutDevInfo();
                    },
                    this
                )
            },
            roomTypeFun(val){
                this.roomType = val;
                if(val == '2'){
                    this.$nextTick(function(){

                        const container = this.$refs.planebaseMap
                        const rect = container.getBoundingClientRect();
                        this.mapBgWidth = rect.width;
                        this.mapBgHeight = rect.height;
                        this.clientWidth = this.mapBgWidth*3/100;
                        this.clientHeight = this.mapBgWidth*3/100;

                        this.draggable(container, {
                            drag: (event) => {
                                if(this.lock == '1'){
                                   this.handleDrag(event,'drag');
                                }else{
                                    this.lockTitleShow = true;
                                    // this.$message({
                                    //     message: 'Unchecked',
                                    //     type: 'warning'
                                    // });
                                }
                            },
                            end: (event) => {
                                if(this.lock == '1'){
                                    this.handleDrag(event,'end');
                                }else{   
                                    this.lockTitleShow = true;   
                                    // this.$message({
                                    //     message: 'Unchecked',
                                    //     type: 'warning'
                                    // });
                                }
                            }
                        })
                        this.getPlaneLayoutInfo('0');
                        this.getPlaneLayoutDevInfo();
                        this.getLayoutImage();

                        this.frameSelectionIsShow = false
                        this.frameSelectionShow = false;
                        this.frameSelectionWidth = 0;
                        this.frameSelectionHeight = 0;
                        this.frameSelectionTop = 0;
                        this.frameSelectionLeft = 0;

                        this.rightClickMenuTop = 0;
                        this.rightClickMenuLeft = 0;
                        this.rightClickMenuShow = 0;
                        this.rightClickMenu_copy_Show = false;
                        this.rightClickMenu_paste_Show = false;
                        this.rightClickMenu_delete_Show = false;
                        this.mapDeviceCopyList = [];
                    })
                }
            },
            mapDeviceTkClose(){
                let this_ = this;
                this.mapDeviceTkShow = false;
                setTimeout(function(){
                    this_.mapDeviceTkShowbg = false;
                },800)
            },
            updateDevInfo(){
                base.ajax_post(
                    allUrl.room.updateDevInfo,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        ...this.mapEditDeviceForm,
                    },
                    {},
                    data=>{
                        this.$message({
                          showClose: true,
                          message: data.msg,
                          type: 'success'
                        });
                        let this_ = this;
                        this.mapEditDeviceTkShow = false;
                        setTimeout(function(){
                            this_.mapEditDeviceTkShowbg = false;
                        },800)
                        this.getPlaneLayoutInfo('0');
                        this.getPlaneLayoutDevInfo();
                    },
                    this
                )
            },
            mapEditDeviceTkClose(){
                let this_ = this;
                this.mapEditDeviceTkShow = false;
                setTimeout(function(){
                    this_.mapEditDeviceTkShowbg = false;
                },800)
            },
            commandMapDeviceType(data){
                // console.log(data)
                let arr = ['lights','circadian lights','sensor','air purifiers'];
                this.mapDeviceForm.list[data.index].type = data.data.id;
                this.mapDeviceForm.list[data.index].name = arr[data.data.id];
            },
            commandMapArrangement(data){
                this.mapDeviceForm.layoutType = data.id;
            },
            mapDeviceFun(){
                this.mapDeviceTkShowbg = true;
                this.$nextTick(function(){
                    this.mapDeviceTkShow = true;
                })
                this.mapDeviceForm.list = [{type:'0',deviceCount:'',name:'lights'}];
               this.mapDeviceForm.layoutType = '0';
               this.mapDeviceForm.columnNumber = 0;
               this.mapDeviceForm.space = 0;
            },
            addMapDevice(){
                this.$set(this.mapDeviceForm.list,this.mapDeviceForm.list.length,{type:'0',name:'lights',deviceCount:''})
            },
            draggable(element, options) {
                let this_ = this;
                const moveFn = function (event) {
                    if (options.drag) {
                        options.drag(event);
                    }
                };
                const upFn = function (event) {
                    document.removeEventListener('mousemove', moveFn);
                    document.removeEventListener('mouseup', upFn);
                    document.onselectstart = null;
                    document.ondragstart = null;

                    this_.isDragging = false;

                    if (options.end) {
                        options.end(event);
                    }
                };
                const container = this_.$refs.mapEditDevice
                container.addEventListener('contextmenu', function (event) {
                    event.preventDefault();
                    event.returnvalue = false;
                    return false;
                })

                element.addEventListener('contextmenu', function (event) {
                    event.preventDefault();
                    event.returnvalue = false;
                    return false;
                })
                const container_ = this_.$refs.planebaseMap;
                const rect_ = container_.getBoundingClientRect();
                element.addEventListener('mousedown', function (event) {
                    // console.log(event.target.className.split(' ')[0],'-----------')
                    this_.offsetX = event.offsetX;
                    this_.offsetY = event.offsetY;
                    this_.buttonType = event.button;
                    if(event.target.className.split(' ')[0] == 'right_click_menu_bg'){
                        this_.rightClickMenuShow = false;
                        this_.rightClickMenu_copy_Show = false;
                        // this_.rightClickMenu_paste_Show = false;
                        this_.rightClickMenu_delete_Show = false;
                    }
                    if(event.target.className.split(' ')[0] == 'room_right_main_map'){
                        this_.dragType = '-1';
                        this_.frameSelectionLeft = event.offsetX;
                        this_.frameSelectionTop = event.offsetY;

                        this_.frameSelectionIsShow = false;
                        this_.frameSelectionShow = false;
                        for(let d of this_.mapDevList){
                            this_.$set(d,'frameSelection',0);
                        }

                        this_.rightClickMenuShow = false;

                        this_.rightClickMenu_copy_Show = false;
                        this_.rightClickMenu_delete_Show = false;
                    }else if(event.target.className.split(' ')[0] == 'map_device'){
                        this_.dragType = event.target.className.split(' ')[1].split('_')[1];
                        this_.dragDeviceId = event.target.className.split(' ')[2];
                        this_.isSave = false;
                        this_.isSaveTime = setTimeout(function(){
                            this_.isSave = true;
                        },200)
                    }else if(event.target.className.split(' ')[0] == 'move'){
                        console.log('------',event)
                        this_.moveLeft = event.clientX - rect_.left - event.offsetX;
                        this_.moveTop = event.clientY - rect_.top - event.offsetY;

                        this_.dragType = '-2';
                        this_.dragDeviceId = '';
                    }else if(event.target.className.split(' ')[0] == 'click_menu_move_top'){
                        // this_.clickMenuMoveTop
                        this_.dragType = '-3';
                        // this_.clickMenuMoveLeft = event.clientX - rect_.left - event.offsetX;
                        // this_.clickMenuMoveTop = event.clientY - rect_.top - event.offsetY;
                    }else{
                        this_.dragType = '';
                        this_.dragDeviceId = '';
                    }
                    if (this_.isDragging) return;
                    document.onselectstart = function () { return false; };
                    document.ondragstart = function () { return false; };

                    document.addEventListener('mousemove', moveFn);
                    document.addEventListener('mouseup', upFn);
                    this_.isDragging = true;

                    if (options.start) {
                        options.start(event);
                    }
                });
                element.addEventListener('mousemove', function (event) {
                    if(event.target.className.split(' ')[0] == 'map_device'){
                        let type = event.target.className.split(' ')[1].split('_')[1];
                        let id = event.target.className.split(' ')[2];
                        this_.deviceTipsShow = true;

                        this_.$nextTick(function(){
                            if(id != this_.deviceInfo.id || type != this_.deviceInfo.type){
                                this_.deviceInfoUpdate = true;
                            }
                            if(this_.deviceInfoUpdate){
                                this_.deviceInfoUpdate = false;
                                for(let d of this_.mapDevList){
                                    if(d.id == id && d.type == type){
                                        this_.deviceInfo.number = d.number;
                                        this_.deviceInfo.deviceId = d.deviceId?d.deviceId:'-';
                                        this_.deviceInfo.name = d.name;
                                        this_.deviceInfo.id = d.id;
                                        this_.deviceInfo.type = d.type;
                                        this_.deviceInfo.status = ((d.status||d.status == '0')&&d.status!='new')?this_.sensorStatusArr[d.status]:'-';
                                        this_.deviceInfo.roomNumber = d.roomNumber?d.roomNumber:'-';
                                        if((parseInt(d.locationY)/100*this_.mapBgHeight+this_.remRatio*12.5)>this_.mapBgHeight){
                                            this_.deviceInfo.locationY = 'calc('+d.locationY +' - '+((parseInt(d.locationY)/100*this_.mapBgHeight+this_.remRatio*12.5) - this_.mapBgHeight + 10)+'px)';
                                            if((parseInt(d.locationX)/100*this_.mapBgWidth+this_.remRatio*14.5)>this_.mapBgWidth){
                                                this_.deviceInfo.locationX = 'calc('+d.locationX +' - '+((parseInt(d.locationX)/100*this_.mapBgWidth+this_.remRatio*14.5) - this_.mapBgWidth + 10 + this_.clientWidth)+'px)';
                                            }else{
                                                this_.deviceInfo.locationX = 'calc('+d.locationX +' + '+this_.clientWidth+'px)';
                                            }
                                        }else{
                                            this_.deviceInfo.locationY = 'calc('+d.locationY +' + '+this_.clientHeight+'px)';
                                            if((parseInt(d.locationX)/100*this_.mapBgWidth+this_.remRatio*14.5)>this_.mapBgWidth){
                                                this_.deviceInfo.locationX = 'calc('+d.locationX +' - '+((parseInt(d.locationX)/100*this_.mapBgWidth+this_.remRatio*14.5) - this_.mapBgWidth + 10)+'px)';
                                            }else{
                                                this_.deviceInfo.locationX = d.locationX;
                                            }
                                        }
                                    }
                                }
                            }
                        })
                    }else{
                        this_.deviceTipsShow = false;
                        this_.deviceInfoUpdate = true;
                    }
                });
            },
            handleDrag(event,type) {
                let this_ = this;
                const container = this.$refs.planebaseMap
                const rect = container.getBoundingClientRect();
                let left = event.clientX - rect.left;
                let top = event.clientY - rect.top;
                left = Math.max(0, left);
                left = Math.min(left, rect.width);

                top = Math.max(0, top);
                top = Math.min(top, rect.height);
                if(this.buttonType == '0'){
                    if(this.dragType == '-1'){
                        if(type == 'drag'){
                            this.frameSelectionShow = true;
                            if(top <= this.offsetY){
                                this.frameSelectionTop = top
                                this.frameSelectionHeight = this.offsetY - top
                                // console.log(top)
                            }else{
                                this.frameSelectionHeight = top - this.offsetY;
                            }
                            if(left <= this.offsetX){
                                this.frameSelectionLeft = left;
                                this.frameSelectionWidth = this.offsetX - left;
                            }else{
                                this.frameSelectionWidth = left - this.offsetX;
                            }
                            this.frameSelectionIsShow = false;
                            for(let d of this.mapDevList){
                                if(
                                    (this.frameSelectionLeft < d.x1 && d.x1 < this.frameSelectionLeft+this.frameSelectionWidth && 
                                        ((this.frameSelectionTop < d.y1 && d.y1 < this.frameSelectionTop+this.frameSelectionHeight)||
                                            (this.frameSelectionTop < d.y2 && d.y2 < this.frameSelectionTop+this.frameSelectionHeight))
                                        )||
                                    (this.frameSelectionLeft < d.x2 && d.x2 < this.frameSelectionLeft+this.frameSelectionWidth && 
                                        ((this.frameSelectionTop < d.y2 && d.y2 < this.frameSelectionTop+this.frameSelectionHeight)||
                                            (this.frameSelectionTop < d.y1 && d.y1 < this.frameSelectionTop+this.frameSelectionHeight))
                                        )
                                    ){
                                    this.$set(d,'frameSelection',1);
                                    this.frameSelectionIsShow = true;
                                }else{
                                    this.$set(d,'frameSelection',0);
                                }
                            }
                        }
                        if(type == 'end'){
                            if(this.mapDevicePasteIsTrue){
                                console.log(this.mapDeviceCopyList)
                                this.copyDevList({
                                    clickLocationX:((event.clientX - rect.left)/ rect.width * 100).toFixed(4)+'%',
                                    clickLocationY:((event.clientY - rect.top)/ rect.height * 100).toFixed(4)+'%',
                                    devList:this.mapDeviceCopyList,
                                })
                                this.frameSelectionIsShow = false;
                                this.frameSelectionShow = false;


                                this.rightClickMenuShow = false;
                                this.rightClickMenu_copy_Show = false;
                                this.rightClickMenu_paste_Show = false;
                                this.rightClickMenu_delete_Show = false;
                                for(let d of this.mapDevList){
                                    this.$set(d,'frameSelection',0);
                                }
                                this.mapDevicePasteIsTrue = false;
                            }
                            if(this.frameSelectionIsShow){
                                this.frameSelectionTop_ = this.frameSelectionTop;
                                this.frameSelectionLeft_ = this.frameSelectionLeft;
                            }else{
                                this.frameSelectionShow = false;
                                this.frameSelectionWidth = 0;
                                this.frameSelectionHeight = 0;
                                this.frameSelectionTop = 0;
                                this.frameSelectionLeft = 0;
                            }
                        }
                    }else if(this.dragType == '0'||this.dragType == '1'||this.dragType == '2'||this.dragType == '3'||this.dragType == '4'||this.dragType == '5'||this.dragType == '6'||this.dragType == '7'){
                        if(this_.isSave){
                            this.svpanelLeft = left - this.offsetX;
                            this.svpanelTop = top - this.offsetY;
                            if(this.svpanelLeft>rect.width - this.clientWidth){
                                this.svpanelLeft = rect.width - this.clientWidth;
                            }
                            if(this.svpanelLeft<0){
                                this.svpanelLeft = 0;
                            }
                            if(this.svpanelTop>rect.height - this.clientHeight){
                                this.svpanelTop = rect.height -this.clientHeight;
                            }
                            if(this.svpanelTop<0){
                                this.svpanelTop = 0;
                            }
                            for(let d of this.mapDevList){
                                if(d.id == this.dragDeviceId && d.type == this.dragType){
                                    this.$set(d,'locationX',(this.svpanelLeft/ rect.width * 100).toFixed(4)+'%');
                                    this.$set(d,'locationY',(this.svpanelTop/ rect.height * 100).toFixed(4)+'%');
                                    this.$set(d,'x1',(this.svpanelLeft).toFixed(4));
                                    this.$set(d,'y1',(this.svpanelTop).toFixed(4));
                                    this.$set(d,'x2',(this.svpanelLeft).toFixed(4)+Number(this.clientWidth.toFixed(4)));
                                    this.$set(d,'y2',(this.svpanelTop).toFixed(4)+Number(this.clientHeight.toFixed(4)));
                                    this.deviceTipsShow = false;
                                    this.deviceInfoUpdate = false;
                                    // this.deviceInfoUpdate = true;
                                }
                            }
                            if(type == 'end'){
                                this.deviceInfoUpdate = true;
                                this.setDevLocation({
                                    devList:[{
                                        devId:this.dragDeviceId,
                                        type:this.dragType,
                                        locationX:(this.svpanelLeft/ rect.width * 100).toFixed(4)+'%',
                                        locationY:(this.svpanelTop/ rect.height * 100).toFixed(4)+'%',
                                    }],
                                })
                                clearTimeout(this.isSaveTime)
                                this.isSave = false
                            }
                        }else{
                            if(type == 'end'){
                                clearTimeout(this.isSaveTime)
                                this.isSave = false
                                for(let d of this.mapDevList){
                                    if(d.id == this.dragDeviceId && d.type == this.dragType){
                                        // console.log(d)
                                        this.mapEditDeviceForm.devId = d.id;
                                        this.getfloorNav(()=>{
                                            if(this.floorNav.length>0){
                                                this.mapEditDeviceForm.floorId = this.floorId;
                                                this.getRoomNav(this.mapEditDeviceForm.floorId,()=>{
                                                    if(this.roomNav.length>0){
                                                        this.mapEditDeviceForm.roomId = d.roomId;
                                                    }
                                                })
                                            }
                                        })
                                        this.mapEditDeviceForm.address = d.deviceId;
                                        this.mapEditDeviceForm.gatewayId = d.gatewayId;
                                        this.mapEditDeviceForm.type = d.type;
                                        this.mapEditDeviceForm.number = d.number;
                                        this.mapEditDeviceForm.name = d.name;
                                    }
                                }
                                this.mapEditDeviceTkShowbg = true;
                                this.$nextTick(function(){
                                    this.mapEditDeviceTkShow = true;
                                    this.deviceTipsShow = false;
                                    this.deviceInfoUpdate = true;
                                })
                            }
                        }
                    }else if(this.dragType == '-2'){
                        if(type == 'drag'){
                            this.svpanelLeft = left - this.offsetX;
                            this.svpanelTop = top - this.offsetY;
                            if(this.svpanelLeft>rect.width - this.clientWidth){
                                this.svpanelLeft = rect.width - this.clientWidth;
                            }
                            if(this.svpanelLeft<0){
                                this.svpanelLeft = 0;
                            }
                            if(this.svpanelTop>rect.height - this.clientHeight){
                                this.svpanelTop = rect.height -this.clientHeight;
                            }
                            if(this.svpanelTop<0){
                                this.svpanelTop = 0;
                            }
                            this.frameSelectionTop = this.frameSelectionTop_+this.svpanelTop-this.moveTop;
                            this.frameSelectionLeft = this.frameSelectionLeft_+this.svpanelLeft-this.moveLeft;
                            for(let d of this.mapDevList){
                                if(d.frameSelection == 1){
                                    this.$set(d,'locationX',((Number(d.x1)+this.svpanelLeft-this.moveLeft)/ rect.width * 100).toFixed(4)+'%');
                                    this.$set(d,'locationY',((Number(d.y1)+this.svpanelTop-this.moveTop)/ rect.height * 100).toFixed(4)+'%');
                                }
                            }
                        }
                        if(type == 'end'){
                            let devList = [];
                            for(let d of this.mapDevList){
                                if(d.frameSelection == 1){
                                    this.$set(d,'x1',(Number(d.x1)+this.svpanelLeft-this.moveLeft).toFixed(4));
                                    this.$set(d,'y1',(Number(d.y1)+this.svpanelTop-this.moveTop).toFixed(4));
                                    this.$set(d,'x2',(Number(d.x1)+this.svpanelLeft-this.moveLeft).toFixed(4)+Number(this.clientWidth.toFixed(4)));
                                    this.$set(d,'y2',(Number(d.y1)+this.svpanelTop-this.moveTop).toFixed(4)+Number(this.clientHeight.toFixed(4)));
                                    devList.push({
                                        devId:d.id,
                                        type:d.type,
                                        locationX:d.locationX,
                                        locationY:d.locationY,
                                    })
                                }
                            }
                            this.setDevLocation({
                                devList:devList,
                            })
                            this.frameSelectionTop_ = this.frameSelectionTop;
                            this.frameSelectionLeft_ = this.frameSelectionLeft;
                            this.moveLeft = this.svpanelLeft;
                            this.moveTop = this.svpanelTop;
                            console.log(this.moveLeft,this.moveTop)
                        }
                    }else if(this.dragType == '-3'){
                        this.svpanelLeft = left - this.offsetX;
                        this.svpanelTop = top - this.offsetY;
                        // console.log(this.svpanelLeft,rect.width - this.clickMenuMoveWidth)
                        if(this.svpanelLeft>rect.width - this.clickMenuMoveWidth){
                            this.svpanelLeft = rect.width - this.clickMenuMoveWidth;
                        }
                        if(this.svpanelLeft<0){
                            this.svpanelLeft = 0;
                        }
                        if(this.svpanelTop>rect.height - this.clickMenuMoveHeight){
                            this.svpanelTop = rect.height -this.clickMenuMoveHeight;
                        }
                        if(this.svpanelTop<0){
                            this.svpanelTop = 0;
                        }
                        // console.log(this.clickMenuMoveTop)
                        this.clickMenuMoveTop = this.svpanelTop;
                        this.clickMenuMoveLeft = this.svpanelLeft;
                    }

                }
                if(this.buttonType == '2'){
                    if(type == 'end'){
                        // if(event.target.className.split(' ')[0] == 'right_click_menu_bg'){
                        //     // this.rightClickMenuLeft = ((event.clientX - rect.left)/ rect.width * 100).toFixed(4)+'%';
                        //     // this.rightClickMenuTop = ((event.clientY - rect.top)/ rect.height * 100).toFixed(4)+'%';

                        //     this.rightClickMenuShow = false;
                        //     this.rightClickMenu_copy_Show = false;
                        //     this.rightClickMenu_paste_Show = false;
                        //     this.rightClickMenu_delete_Show = false;
                        // }
                        if(event.target.className.split(' ')[0] == 'map_device'){
                            this.rightClickMenuDevId = event.target.className.split(' ')[2];
                            this.rightClickMenuLeft = ((event.clientX - rect.left)/ rect.width * 100).toFixed(4)+'%';
                            this.rightClickMenuTop = ((event.clientY - rect.top)/ rect.height * 100).toFixed(4)+'%';

                            this.rightClickMenuShow = true;
                            this.rightClickMenu_copy_Show = true;
                            this.rightClickMenu_paste_Show = false;
                            this.rightClickMenu_delete_Show = true;
                            this.rightClickMenuType = 1;
                        }
                        if(event.target.className.split(' ')[0] == 'frame_selection'){
                            this.rightClickMenuLeft = ((event.clientX - rect.left)/ rect.width * 100).toFixed(4)+'%';
                            this.rightClickMenuTop = ((event.clientY - rect.top)/ rect.height * 100).toFixed(4)+'%';

                            this.rightClickMenuShow = true;
                            this.rightClickMenu_copy_Show = true;
                            this.rightClickMenu_paste_Show = false;
                            this.rightClickMenu_delete_Show = true;
                            this.rightClickMenuType = 2;
                        }
                        if(event.target.className.split(' ')[0] == 'room_right_main_map'){
                            this.rightClickMenuLeft = (event.offsetX/ rect.width * 100).toFixed(4)+'%';
                            this.rightClickMenuTop = (event.offsetY/ rect.height * 100).toFixed(4)+'%';


                            this.clickLocationX = ((event.clientX - rect.left)/ rect.width * 100).toFixed(4)+'%';
                            this.clickLocationY = ((event.clientY - rect.top)/ rect.height * 100).toFixed(4)+'%';
                            if(this.mapDeviceCopyList.length>0){
                                this.rightClickMenu_paste_Show = true;
                            }
                            if(this.rightClickMenu_paste_Show){
                                this.rightClickMenuShow = true;
                            }
                        }
                    }
                }
                // console.log(left,top,this.dragType,this.clientWidth)
            },
            rightClickMenuClose(){
                this.rightClickMenuShow = false;
                this.rightClickMenu_copy_Show = false;
                // this.rightClickMenu_paste_Show = false;
                this.rightClickMenu_delete_Show = false;
            },
            mapDeviceCopy(type){
                if(type == 'click'){
                    let isTrue = true;
                    this.rightClickMenuType = 2;
                    for(let d of this.mapDevList){
                        if(d.frameSelection == 1){
                            isTrue = false;
                        }
                    }
                    if(isTrue){
                        this.$message({
                            message: 'Please select the devices',
                            type: 'warning'
                        });
                        return
                    }
                }
                this.rightClickMenuShow = false;
                this.rightClickMenu_copy_Show = false;
                this.rightClickMenu_paste_Show = true;
                this.rightClickMenu_delete_Show = false;
                this.mapDeviceCopyList = [];
                if(this.rightClickMenuType == 1){
                    for(let d of this.mapDevList){
                        if(d.id == this.rightClickMenuDevId){
                            this.mapDeviceCopyList.push({
                                type:d.type,
                                locationX:parseFloat(d.locationX),
                                locationY:parseFloat(d.locationY),
                            })
                        }
                    }
                }else{
                    for(let d of this.mapDevList){
                        if(d.frameSelection == 1){
                            this.mapDeviceCopyList.push({
                                type:d.type,
                                locationX:parseFloat(d.locationX),
                                locationY:parseFloat(d.locationY),
                            })
                        }
                    }
                }
                if(type == 'click'){
                    this.frameSelectionShow = false;
                }
                console.log(this.mapDeviceCopyList,this.rightClickMenuType)
            },
            mapDevicePaste(type){
                if(type == 'click'){
                    if(this.mapDevicePasteIsTrue){
                        this.mapDevicePasteIsTrue = false;
                    }else{
                        if(this.mapDeviceCopyList.length>0){
                            this.mapDevicePasteIsTrue = true;
                        }else{
                            this.$message({
                                message: 'Please copy the device first',
                                type: 'warning'
                            });
                        }
                    }
                }else{
                    this.copyDevList({
                        clickLocationX:this.clickLocationX,
                        clickLocationY:this.clickLocationY,
                        devList:this.mapDeviceCopyList,
                    })
                    this.frameSelectionIsShow = false;
                    this.frameSelectionShow = false;


                    this.rightClickMenuShow = false;
                    this.rightClickMenu_copy_Show = false;
                    this.rightClickMenu_paste_Show = false;
                    this.rightClickMenu_delete_Show = false;
                    for(let d of this.mapDevList){
                        this.$set(d,'frameSelection',0);
                    }
                }
            },
            mapDeviceDel(type){
                if(type == 'click'){
                    let devList = [];
                    for(let d of this.mapDevList){
                        if(d.frameSelection == 1){
                            devList.push({
                                id:d.id,
                                type:d.type,
                            })
                        }
                    }
                    console.log(devList,this.mapDevList)
                    if(devList.length == 0){
                        this.$message({
                            message: 'Please select the devices',
                            type: 'warning'
                        });
                        return
                    }
                    this.rightClickMenuType = 2;
                }
                this.$confirm(this.$t('App.message.text3'), this.$t('App.message.text4'), {
                    confirmButtonText: this.$t('App.message.text5'),
                    cancelButtonText: this.$t('App.message.text6'),
                    type: 'warning'
                }).then(() => {
                    let devList = [];
                    if(this.rightClickMenuType == 1){
                        for(let d of this.mapDevList){
                            if(d.id == this.rightClickMenuDevId){
                                devList.push({
                                    id:d.id,
                                    type:d.type,
                                })
                            }
                        }
                    }else{
                        for(let d of this.mapDevList){
                            if(d.frameSelection == 1){
                                devList.push({
                                    id:d.id,
                                    type:d.type,
                                })
                            }
                        }
                    }
                    // console.log(this.rightClickMenuType,devList)
                    this.delDevList({
                        devList:devList,
                    })
                    this.frameSelectionIsShow = false;
                    this.frameSelectionShow = false;

                    this.rightClickMenuShow = false;
                    this.rightClickMenu_copy_Show = false;
                    this.rightClickMenu_paste_Show = false;
                    this.rightClickMenu_delete_Show = false;
                    for(let d of this.mapDevList){
                        this.$set(d,'frameSelection',0);
                    }
                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: this.$t('App.message.text7')
                  });
                });
            },
            /*修改设备位置信息*/
            setDevLocation(data){
                base.ajax_post(
                    allUrl.room.setDevLocation,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        devList:data.devList,
                    },
                    {},
                    data=>{
                        this.$message({
                          showClose: true,
                          message: data.msg,
                          type: 'success'
                        });
                    },
                    this
                )
            },
            /*拷贝设备*/
            copyDevList(data){
                console.log(data)
                base.ajax_post(
                    allUrl.room.copyDevList,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        floorId:this.floorId,
                        clickLocationX:data.clickLocationX,
                        clickLocationY:data.clickLocationY,
                        devList:data.devList,
                    },
                    {},
                    data=>{
                        this.mapDeviceCopyList = [];
                        this.getPlaneLayoutInfo('0');
                        this.$message({
                          showClose: true,
                          message: data.msg,
                          type: 'success'
                        });
                    },
                    this
                )
            },
            /*删除设备*/
            delDevList(data){
                if(data.devList.length>0){
                    base.ajax_post(
                        allUrl.room.delDev,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            devList:data.devList,
                        },
                        {},
                        data=>{
                            this.getPlaneLayoutInfo('0');
                            this.$message({
                              showClose: true,
                              message: data.msg,
                              type: 'success'
                            });
                        },
                        this
                    )
                }
            },
            roomCmd(){
                base.ajax_postWs(
                    allUrl.roomLight.lampCmd,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        roomId:this.roomForm.roomId,
                        type:1,
                        light: parseInt(this.roomForm.light),
                        status:this.roomForm.status,
                        color: parseInt(this.roomForm.color),
                        colorR:this.roomForm.colorR,
                        colorG:this.roomForm.colorG,
                        colorB:this.roomForm.colorB,
                        clientId:this.clientid,
                    },
                    this
                )
            },
            commandHide(val){
                this.$nextTick(function(){
                    if($('.'+val)&&$('.'+val+' >.select').offset()){
                        $('.'+val).animate({scrollTop: $('.'+val).scrollTop() + $('.'+val+' >.select').offset().top - $('.'+val).offset().top - 100})
                    }
                })
            },
            commandRoomFloor(data){
                this.roomForm.floorId = data.id;
                this.getRoomNav(this.roomForm.floorId,()=>{
                    if(this.roomNav.length>0){
                        this.roomForm.roomId = this.roomNav[0].id;
                    }
                })
            },
            commandRoomRoom(data){
                this.roomForm.roomId = data.id;
            },
            commandDeviceFloor(data){
                this.mapEditDeviceForm.floorId = data.id;
                this.getRoomNav(this.mapEditDeviceForm.floorId,()=>{
                    if(this.roomNav.length>0){
                        this.mapEditDeviceForm.roomId = this.roomNav[0].id;
                    }
                })
            },
            commandDeviceRoom(data){
                this.mapEditDeviceForm.roomId = data.id;
            },

            floorBGTypeFun(val){
                this.floorBGType = val;
                if(val == '0'){
                    this.floorBuildImageSrc = this.floorBuildImage.buildImage;
                }else{
                    this.floorBuildImageSrc = this.floorBuildImage.floorImage;
                }
            },
            buildChange(){
                this.getroomList('upDate',()=>{
                    if(this.floorRoomList.length > 0){
                        this.floorId = this.floorRoomList[0].id;
                        this.floorName = this.floorRoomList[0].name;
                        this.roomList = this.floorRoomList[0].roomList;
                        if(this.roomType == '2'){
                            this.getPlaneLayoutInfo('0');
                            this.getPlaneLayoutDevInfo();
                            this.getLayoutImage();
                        }
                    }
                })
            },
            colorChange(isTrue,valueR,valueG,valueB){
                this.roomForm.colorR = valueR;
                this.roomForm.colorG = valueG;
                this.roomForm.colorB = valueB;
            },
            colorValueChange(valueR,valueG,valueB){
                this.roomForm.colorR = valueR;
                this.roomForm.colorG = valueG;
                this.roomForm.colorB = valueB;
            },
            plSwitchFun(){
                if(this.value5 == 0){
                    this.value5 = 1
                }else{
                    this.value5 = 0
                }
            },
            handleCommand(){

            },
            floorPlanFun(){
                this.floorPlanTkShowbg = true;
                this.$nextTick(function(){
                    this.floorPlanTkShow = true;
                })
                this.getFloorBuildImage(()=>{
                    if(this.floorBGType == '0'){
                        this.floorBuildImageSrc = this.floorBuildImage.buildImage;
                    }else{
                        this.floorBuildImageSrc = this.floorBuildImage.floorImage;
                    }
                });
            },
            floorPlanTkClose(){
                let this_ = this;
                this.floorPlanTkShow = false;
                setTimeout(function(){
                    this_.floorPlanTkShowbg = false;
                },800)
            },
            centralizedSettingFun(){
                this.centralizedSettingTkShowbg = true;
                this.$nextTick(function(){
                    this.centralizedSettingTkShow = true;
                })
                this.roomForm = {
                    floorId:'',
                    roomId:'',
                    light:0,
                    color:0,
                    colorR:0,
                    colorG:0,
                    colorB:0,
                    status:1,
                    level:1,
                }
                if(this.$refs.colorPicker){
                    this.$refs.colorPicker.setColorValue('rgb('+this.roomForm.colorR+','+this.roomForm.colorG+','+this.roomForm.colorB+')');
                }
                this.getfloorNav(()=>{
                    if(this.floorNav.length>0){
                        this.roomForm.floorId = this.floorNav[0].id;
                        this.getRoomNav(this.roomForm.floorId,()=>{
                            if(this.roomNav.length>0){
                                this.roomForm.roomId = this.roomNav[0].id;
                            }
                        })
                    }
                })

                // console.log(this.floorNav)
            },
            centralizedSettingTkClose(){
                let this_ = this;
                this.centralizedSettingTkShow = false;
                setTimeout(function(){
                    this_.centralizedSettingTkShowbg = false;
                },800)
            },
            getFloorBuildImage(callback){
                base.ajax_post(
                    allUrl.room.floorBuildImage,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        floorId:this.floorId,
                    },
                    {},
                    data=>{
                        this.floorBuildImage = data.data;
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*楼房下拉列表*/
            getbuildNav(callback){
                if(this.hotelId){
                    base.ajax_post(
                        allUrl.room.buildNav,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            hotelId:this.hotelId,
                        },
                        {},
                        data=>{
                            this.buildNav = data.data.list;
                            if(callback){
                                callback(data)
                            }
                        },
                        this
                    )
                }
            },
            /*房间列表*/
            getroomListKeyUp(e,type){
                if(e.key == 'Enter'){
                  this.getroomList(type);
                }
            },
            getroomList(type,callback){
                this.loading.roomList = true;
                base.ajax_post(
                    allUrl.room.roomList,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        keywords:this.keywords,
                        buildId:this.buildId,
                    },
                    {},
                    data=>{
                        this.loading.roomList = false;
                        this.floorRoomList = data.data.list;
                        if(type == 'search'){
                            if(this.floorRoomList.length > 0){
                                this.floorId = this.floorRoomList[0].id;
                                if(this.roomType == '1'){
                                    this.roomList = this.floorRoomList[0].roomList;
                                    this.floorIndex = 1;
                                    // this.roomList = data.roomList;
                                }else{
                                    this.getPlaneLayoutInfo('0');
                                    this.getPlaneLayoutDevInfo();
                                    this.getLayoutImage();
                                }
                            }else{
                                this.floorId = null;
                                this.roomList = [];
                                this.floorIndex = null;
                            }
                        }
                        if(callback){
                                callback(data)
                        }
                    },
                    this,()=>{
                        this.loading.roomList = false;
                    }
                )
            },
            /*楼层下拉列表*/
            getfloorNav(callback){
                base.ajax_post(
                    allUrl.room.floorNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        buildId:this.buildId,
                    },
                    {},
                    data=>{
                        this.floorNav = data.data.list;
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*房间下拉列表*/
            getRoomNav(id,callback){
                base.ajax_post(
                    allUrl.room.roomNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        buildId:this.buildId,
                        floorId:id,
                    },
                    {},
                    data=>{
                        this.roomNav = data.data.list;
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            floorSelectFun(data,val){
                this.floorId = data.id;
                this.floorName = data.name;
                this.floorIndex = val+1;
                this.roomRightMainLB = 0;
                if(this.roomType == '1'){
                    this.roomList = data.roomList;
                }else{
                    this.getPlaneLayoutInfo('0');
                    this.getPlaneLayoutDevInfo();
                    this.getLayoutImage();
                }
            },
            linkToFun(data,val){
                console.log(data)
                var storage = window.localStorage;
                storage.setItem('roomRoomId',data.id);
                storage.setItem('roomRoomName',data.number);
                storage.setItem('buildId',this.buildId);
                storage.setItem('buildIdName',this.buildName);
                storage.setItem('deviceType','0');
                this.$router.push({path:val});
                this.$store.commit('ROUTERSTRFUN',{
                    routerStr:val,
                })
                
            },
            scrollNavFun(e){
                let boxHeight = parseInt($('.room_main .room_right .room_right_main .room_right_main_l').css('height'));
                this.roomRightMainLB = 0;
                if(e.target.scrollTop>this.floorIndex*2.5*this.remRatio){
                    this.roomRightMainLB = 1
                }
                if(e.target.scrollTop < (this.floorIndex*2.5*this.remRatio - boxHeight)){
                    this.roomRightMainLB = 2
                }
            }
        },
        watch:{
            lockTitleShow:function(){
                if(this.lockTitleShow){

                    this.$message({
                      showClose: true,
                      message: 'Not unlocked',
                      type: 'warning'
                    });
                    let this_ = this;
                    clearTimeout(this_.lockTitleShowTime)
                    this.lockTitleShowTime = setTimeout(function(){
                        this_.lockTitleShow = false;
                        clearTimeout(this_.lockTitleShowTime)
                    },3000)
                }
            },
            buildId:function(){
                var storage = window.localStorage;
                storage.setItem('buildIdNav',this.buildId)
                for(let d of this.buildNav){
                    if(d.id == this.buildId){
                        this.buildName = d.name
                    }
                }
            },
            hotelId:function(){
                var storage = window.localStorage;
                if(this.hotelId){
                    this.getbuildNav(()=>{
                        if(this.buildNav.length > 0){
                            if(storage.getItem('buildIdNav')){
                                let isbuildId = true;
                                for(let d of this.buildNav){
                                    if(d.id == storage.getItem('buildIdNav')){
                                        this.buildId = d.id;
                                        isbuildId = false;
                                    }
                                }
                                if(isbuildId){
                                    this.buildId = this.buildNav[0].id;
                                }
                            }else{
                                this.buildId = this.buildNav[0].id;
                            }
                            // this.buildId = this.buildNav[0].id;
                            this.getroomList('upDate',()=>{
                                if(this.floorRoomList.length > 0){
                                    this.floorId = this.floorRoomList[0].id;
                                    this.floorName = this.floorRoomList[0].name;
                                    this.roomList = this.floorRoomList[0].roomList;

                                    this.floorIndex = 1;
                                    if(this.roomType == '2'){
                                        this.getPlaneLayoutInfo('0');
                                        this.getPlaneLayoutDevInfo();
                                        this.getLayoutImage();
                                    }
                                }else{
                                    this.floorId = '';
                                    this.floorName = '';
                                    this.roomList = [];
                                    this.floorIndex = 1;
                                }
                            })
                        }else{
                            this.buildId = '';
                            this.floorRoomList =[];
                            this.floorId = '';
                            this.floorName = '';
                            this.roomList = [];
                            this.floorIndex = 1;
                        }
                    });
                }  
            }
        }
    }
</script>

<style type="text/css" lang="less">
    .room_main{
        width: 100%;
        height: 100%;
        // height: 105rem;
        min-height: 50rem;
        // min-width: 120rem;
        margin: 0 auto;
        overflow: hidden;
        position: relative;
        display: flex;
        background: #F6F8FA;
        &.cn{
            .room_right{
                .room_right_top{
                    .right_top_l{
                        .switch_box{
                            .div{
                                &.select{
                                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                                }
                            }
                        }
                        >.el-input{
                            .el-icon-search{
                                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                            }
                        }
                    }
                    .right_top_r{
                        .btn{
                            i{
                                margin-right: 0.5rem;
                                color: #7E65D2;
                                font-size: 1rem;
                            }
                        }
                    }
                }
                .room_right_main{
                    .room_right_main_l{
                        .li{
                            &:hover{
                                color: #8266C7;
                            }
                            &.select{
                                color: #8266C7;
                                border-right-color: #8266C7;
                            }
                        }
                    }
                    .room_right_main_r{
                        .li{
                            background-image: url('../img/room_bg_v1.png');
                            &:hover{
                                box-shadow: 0.1rem 0.1rem 0.3rem #666;
                            }
                            .box1 .text_box .p1{
                                margin-top: 0.2rem;
                                font-size: 1.6rem;
                            }
                        }
                    }
                    .room_right_main_map_bg{
                        .deviceLock_box{
                            .deviceLock_bg{
                                &.unlock{
                                    background-color: rgba(62,50,139,0.5);
                                }
                            }
                        }
                        .right_click_menu_box{
                            .right_click_menu{
                                .div{
                                    &:hover{
                                        background-color: #F5F0FF;
                                        span{
                                            color: #513C93;
                                        }
                                    }
                                    &.div1{
                                        &:hover{
                                            i{
                                                background-image: url(../img/room/map/paste_1_v1.png);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        .click_menu_move{
                            .div{
                                &:hover{
                                    background-color: #F5F0FF;
                                    span{
                                        color: #513C93;
                                    }
                                }
                                &.div1{
                                    &:hover{
                                        i{
                                            background-image: url(../img/room/map/paste_1_v1.png);
                                        }
                                    }
                                }
                            }
                        }
                        .frame_selection{
                            background:linear-gradient(89deg,rgba(124,93,156,0.5) 0%,rgba(62,50,139,0.5) 100%);
                            border-color:rgba(62,50,139,0.5);
                            .move{
                                border-color: rgba(62,50,139,0.5);
                            }
                        }
                        .map_tips{
                            .div3{
                                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                            }
                        }
                        .map_device{
                            &.type_0{
                                &.status_1{
                                    background-image:url('../img/room/map/map_device_0_1_v1.png');
                                    &:hover{
                                        background-image:url('../img/room/map/map_device_0_1_hover_v1.png');
                                    }
                                    &.frameSelection_1{
                                        background-image:url('../img/room/map/map_device_0_1_hover_v1.png');
                                    }
                                }
                            }
                            &.type_1{
                                &.status_1{
                                    background-image:url('../img/room/map/map_device_1_1_v1.png');
                                    &:hover{
                                        background-image:url('../img/room/map/map_device_1_1_hover_v1.png');
                                    }
                                    &.frameSelection_1{
                                        background-image:url('../img/room/map/map_device_1_1_hover_v1.png');
                                    }
                                }
                            }
                            &.type_2{
                                &.status_1{
                                    background-image:url('../img/room/map/map_device_2_1_v1.png');
                                    &:hover{
                                        background-image:url('../img/room/map/map_device_2_1_hover_v1.png');
                                    }
                                    &.frameSelection_1{
                                        background-image:url('../img/room/map/map_device_2_1_hover_v1.png');
                                    }
                                }
                            }
                            &.type_3{
                                &.status_1{
                                    background-image:url('../img/room/map/map_device_3_1_v1.png');
                                    &:hover{
                                        background-image:url('../img/room/map/map_device_3_1_hover_v1.png');
                                    }
                                    &.frameSelection_1{
                                        background-image:url('../img/room/map/map_device_3_1_hover_v1.png');
                                    }
                                }
                            }
                            &.type_4{
                                &.status_1{
                                    background-image:url('../img/room/map/map_device_0_1_v1.png');
                                    &:hover{
                                        background-image:url('../img/room/map/map_device_0_1_hover_v1.png');
                                    }
                                    &.frameSelection_1{
                                        background-image:url('../img/room/map/map_device_0_1_hover_v1.png');
                                    }
                                }
                            }
                            &.type_5{
                                &.status_1{
                                    background-image:url('../img/room/map/map_device_0_1_v1.png');
                                    &:hover{
                                        background-image:url('../img/room/map/map_device_0_1_hover_v1.png');
                                    }
                                    &.frameSelection_1{
                                        background-image:url('../img/room/map/map_device_0_1_hover_v1.png');
                                    }
                                }
                            }
                            &.type_6{
                                &.status_1{
                                    background-image:url('../img/room/map/map_device_0_1_v1.png');
                                    &:hover{
                                        background-image:url('../img/room/map/map_device_0_1_hover_v1.png');
                                    }
                                    &.frameSelection_1{
                                        background-image:url('../img/room/map/map_device_0_1_hover_v1.png');
                                    }
                                }
                            }
                            &.type_7{
                                &.status_1{
                                    background-image:url('../img/room/map/map_device_0_1_v1.png');
                                    &:hover{
                                        background-image:url('../img/room/map/map_device_0_1_hover_v1.png');
                                    }
                                    &.frameSelection_1{
                                        background-image:url('../img/room/map/map_device_0_1_hover_v1.png');
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .centralizedSetting_wrap{
                .centralizedSetting_box{
                    .form{
                        .form_item1{
                            .slider1{
                                .el-slider__bar{
                                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                                }
                                .el-slider__button{
                                    background-color: #513C93;
                                }
                            }
                        }
                        .form_item{
                            .li_r{
                                .pl_switch{
                                    background:rgba(130,102,199,0.2);
                                    &.checked{
                                        background:rgba(130,102,199,0.2);
                                        &::after{
                                            background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .btn_box{
                        .btn{
                            background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                        }
                    }
                }
            }
            .floorPlan_wrap{
                .floorPlan_box{
                    .floorPlan_topNav{
                        .li.select{
                            background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                        }
                    }
                }
            }
            .map_binding_wrap{
                .tk_box{
                    .switch_box{
                        .div{
                            &.select{
                                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                            }
                        }
                    }
                    .form{
                        .tabs1{
                            .span2{
                                &.select{
                                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                                }
                            }
                        }
                        .ul{
                            .li{
                                .r{
                                    .btn{
                                        &.select{
                                            background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                                        }
                                    }
                                }
                                .img_box{
                                    .img{
                                        width: 60%;
                                        &.img_2{
                                            width: 40%;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .btn_box{
                        .btn{
                            background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                        }
                    }
                }
            }
            .map_floorplan_wrap{
                .tabs{
                    background:rgba(130,102,199,0.1);
                    .span1{
                        background-color:#8266C7;
                    }
                }
                .item_title{
                    .div{
                        i{
                            background-color:#8266C7;
                        }
                    }
                }
                .tk_box{
                    .btn_box{
                        .btn{
                            background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                        }
                    }
                }
            }
            .mapDevice{
                .mapDevice_box{
                    .btn{
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                }
            }
        }
        .room_left{
            width: 11.67rem;
            height: 100%;
            min-width: 130px;
        }
        .room_right{
            position: relative;
            padding: 1.92rem 1.5rem 0;
            width: calc(100% - 11.67rem);
            height: calc(100% - 4rem);
            .room_right_top{
                display: flex;
                justify-content: space-between;
                .right_top_l{
                    display: flex;
                    .switch_box{
                        // width:128px;
                        height:2.5rem;line-height: 2.5rem;
                        background:rgba(255,255,255,1);
                        border-radius:1.5rem;
                        display: flex;
                        margin-right: 1rem;
                        .div{
                            cursor: pointer;
                            padding: 0 1.5rem;
                            font-size:1rem;
                            font-family:AlibabaPuHuiTiR;
                            color:rgba(51,51,51,1);
                            &.select{
                                color:rgba(255,255,255,1);
                                background:rgba(5,207,171,1);
                                border-radius:1.67rem;
                            }
                        }
                    }
                    .el-input__inner{
                        height: 2.5rem;line-height: 2.5rem;
                        border-radius: 1.25rem;
                        font-family: AlibabaPuHuiTiR;
                        font-size: 1rem;
                        color: #333333;
                        border-color: #F0F0F0;
                    }
                    .el-input__icon{
                        height: 2.5rem;line-height: 2.5rem;
                    }
                    .el-select{
                        width: 11.42rem;
                    }
                    >.el-input{
                        margin-left: 1rem;
                        width: 18rem;
                        .el-icon-search{
                            display: inline-block;
                            top: 0;bottom: 0;
                            right: 0;
                            width: 4rem;
                            background: #05CFAB;
                            border-radius: 1.25rem;
                            cursor: pointer;
                            color: #FFFFFF;
                        }
                        .el-input__suffix{
                            right: 0;
                        }
                    }
                }
                .right_top_r{
                    display: flex;
                    align-items: center;
                    .btn{
                        margin-left: 1rem;
                        height: 2.5rem;line-height: 2.5rem;
                        padding: 0 1.25rem;
                        background: #FFFFFF;
                        border: 1px solid #F0F0F0;
                        border-radius: 1.25rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #333333;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        img{
                            margin-right: 0.5rem;
                            height: 1.5rem;
                        }
                        i{
                            margin-right: 0.5rem;
                            color: #05CFAB;
                            font-size: 1rem;
                        }
                    }
                    .tps{
                        // margin-left: 1rem;
                        height: 2.5rem;line-height: 2.5rem;
                        color:red;
                    }
                    .pl_switch{
                        margin-left: 1rem;
                        position: relative;
                        display: inline-block;
                        width: 4.5rem;
                        height: 2rem;
                        background: #E1EAF1;
                        border-radius: 2rem;
                        cursor: pointer;
                        &::after{
                            position: absolute;
                            left: 0.25rem;top: 0.25rem;
                            width: 1.5rem;height: 1.5rem;border-radius: 50%;
                            content: '';
                            background: #A3AFBB;
                            transition: all 0.5s;
                        }
                        &.checked{
                            background: #E1F1E7;
                            &::after{
                                left: 2.5rem;
                                background: #05CFAB;
                            }
                        }
                    }
                }
            }
            .room_right_main{
                display: flex;
                height: 100%;
                margin-top: 1.67rem;
                position: relative;
                >.border_t{
                    position: absolute;
                    top: 0;left: 3.5rem;
                    width: 0rem;height: 2.5rem;
                    border-right: 2px solid rgba(5,207,171,1);
                }
                >.border_b{
                    position: absolute;
                    bottom: 0;left: 3.5rem;
                    width: 0rem;height: 2.5rem;
                    border-right: 2px solid rgba(5,207,171,1);
                }
                .room_right_main_l{
                    height: 100%;
                    width: 4rem;text-align: center;
                    .ul{
                        min-height:100%;
                        margin-right: 0.2rem;
                        border-right: 0.1rem solid rgba(198,205,213,0.4);
                    }
                    .li{
                        height: 2.5rem;line-height: 2.5rem;
                        font-family: AlibabaPuHuiTiR;
                        font-size: 1rem;
                        color: #333333;
                        cursor: pointer;
                        &:hover{
                            color: rgba(5, 207, 171, 0.6);
                        }
                        &.select{
                            position: relative;
                            left: 0.1rem;
                            font-family: AlibabaPuHuiTiM;
                            font-size: 1rem;
                            color: #05CFAB;
                            border-right: 0.1rem solid rgba(5,207,171,1);
                        }
                    }
                }
                .room_right_main_map_bg{
                    width: calc(100% - 5rem);
                    margin: 0 0rem 1.67rem 1rem;
                    position:relative;
                    background-position:center;
                    background-size:100% 100%;
                    background-image:url('../img/room/map/map_bg.png');
                    .deviceLock_box{
                        position: absolute;
                        top: 0;
                        right: 0;
                        width: 2.8rem;
                        height: 2.9rem;
                        overflow: hidden;
                        cursor: pointer;
                        .deviceLock_bg{
                            position: absolute;
                            width: 5.6rem;height: 5.8rem;
                            top: -2.9rem;right: -2.8rem;
                            background-color: rgba(255, 201, 54, 0.6);
                            border-radius: 50%;
                            &.unlock{
                                background-color: rgba(5, 207, 171, 0.6);
                            }
                        }
                        .iconfont{
                            position: absolute;
                            top: 0.6rem;
                            right: 0.6rem;
                            z-index: 1;
                            color:#fff;
                            font-size: 1rem;
                        }
                    }
                    .room_right_main_map{
                        width: 100%;height: 100%;
                        position:relative;
                        overflow: hidden;
                        background-position:center;
                        background-size:100% 100%;
                    }
                    .right_click_menu_box{
                        position: absolute;
                        top: 0;left: 0;
                        width: 100%;height: 100%;
                        .right_click_menu_bg{
                            position: absolute;
                            top: 0;left: 0;
                            width: 100%;height: 100%;
                        }
                        .right_click_menu{
                            position:absolute;
                            width:9.2rem;
                            background:rgba(255,255,255,1);
                            border-radius:0.17rem;
                            box-shadow:0rem 0.17rem 0.83rem 0rem rgba(101,112,133,0.2);
                            .div{
                                height:2.2rem;line-height: 2.2rem;
                                display: flex;
                                align-items: center;
                                cursor: context-menu;
                                i{
                                    display: inline-block;
                                    margin: 0 0.5rem 0 1rem;
                                    width: 1rem;height: 1rem;
                                    background-size: 100% 100%;
                                    background-position:center;
                                    // background-image: url(../img/room/map);
                                }
                                span{
                                    font-size:1rem;
                                    font-family:PingFangSC-Semibold,PingFang SC;
                                    font-weight:600;
                                    color:rgba(51,51,51,1);
                                }
                                &:hover{
                                    background:rgba(230,250,246,1);
                                    span{
                                        color:rgba(5,207,171,1);
                                    }
                                }
                                &.div1{
                                    i{
                                        background-image: url(../img/room/map/copy_0.png);
                                    }
                                    &:hover{
                                        i{
                                            background-image: url(../img/room/map/copy_1.png);
                                        }
                                    }
                                }
                                &.div2{
                                    i{
                                        background-image: url(../img/room/map/paste_0.png);
                                    }
                                    &:hover{
                                        i{
                                            background-image: url(../img/room/map/paste_1.png);
                                        }
                                    }
                                }
                                &.div3{
                                    i{
                                        background-image: url(../img/room/map/delete_0.png);
                                    }
                                    &:hover{
                                        i{
                                            background-image: url(../img/room/map/delete_1.png);
                                        }
                                    }
                                }
                            }
                        }
                    }

                    .click_menu_move{
                        position:absolute;
                        width:7.5rem;
                        // height: 9rem;
                        background:rgba(255,255,255,1);
                        border-radius:0.17rem;
                        box-shadow:0rem 0.17rem 0.83rem 0rem rgba(101,112,133,0.2);
                        .click_menu_move_top{
                            width: 100%;
                            height: 2.3rem;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            cursor: pointer;

                            background-image: url(../img/room/map/move_top.png);
                            background-size: 60% 40%;
                            background-position: center;
                            background-repeat: no-repeat;
                            // img{
                            //     max-width: 100%;
                            //     height: 0.8rem;
                            // }
                        }
                        .div{
                            height:2.2rem;line-height: 2.2rem;
                            display: flex;
                            align-items: center;
                            cursor: context-menu;
                            i{
                                display: inline-block;
                                margin: 0 0.5rem 0 1rem;
                                width: 1rem;height: 1rem;
                                background-size: 100% 100%;
                                background-position:center;
                                // background-image: url(../img/room/map);
                            }
                            span{
                                font-size:1rem;
                                font-family:PingFangSC-Semibold,PingFang SC;
                                font-weight:600;
                                color:rgba(51,51,51,1);
                            }
                            &:hover,&.select{
                                background:rgba(230,250,246,1);
                                span{
                                    color:rgba(5,207,171,1);
                                }
                            }
                            &.div1{
                                i{
                                    background-image: url(../img/room/map/copy_0.png);
                                }
                                &:hover{
                                    i{
                                        background-image: url(../img/room/map/copy_1.png);
                                    }
                                }
                            }
                            &.div2{
                                i{
                                    background-image: url(../img/room/map/paste_0.png);
                                }
                                &:hover,&.select{
                                    i{
                                        background-image: url(../img/room/map/paste_1.png);
                                    }
                                }
                            }
                            &.div3{
                                i{
                                    background-image: url(../img/room/map/delete_0.png);
                                }
                                &:hover{
                                    i{
                                        background-image: url(../img/room/map/delete_1.png);
                                    }
                                }
                            }
                        }
                    }
                    .device_tips{
                        position:absolute;
                        width:14.5rem;
                        height:12.5rem;
                        background:rgba(255,255,255,1);
                        box-shadow:0rem 0.25rem 0.67rem 0rem rgba(101,112,133,0.15);
                        border-radius:0.17rem;
                        border:0.08rem solid rgba(5,207,171,1);
                        p{
                            display: flex;
                            justify-content: space-between;
                            margin: 0.5rem 0;
                            .span1{
                                width: 5.5rem;
                                padding-left: 1.2rem;
                                font-size:1rem;
                                font-family:AlibabaPuHuiTiR;
                                color:rgba(51,51,51,1);
                            }
                            .span2{
                                flex: 1;
                                font-size:1rem;
                                font-family:AlibabaPuHuiTiR;
                                color:rgba(101,112,133,1);

                                display: inline-block;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                vertical-align: middle;
                            }
                        }
                    }
                    .map_tips{
                        position:absolute;
                        bottom: 10.8rem;left: 0;
                        &:hover{
                            .div1{
                                display: block;
                            }
                            .div2{
                                display: flex;
                            }
                        }
                        .div1{
                            position: absolute;
                            width:18rem;
                            height:7.5rem;
                            border-left: 0.2rem solid rgba(5,207,171,1);
                            background:rgba(255,255,255,1);
                            display: none;
                            p{
                                display: flex;
                                justify-content: space-between;
                                align-items:center;
                                &.p1{
                                    margin-top: 1rem;
                                    i{
                                        background:rgba(5,207,171,1);
                                    }
                                }
                                &.p2{
                                    margin-top: 0.5rem;
                                    i{
                                        background:rgba(255,219,0,1);
                                    }
                                }
                                &.p3{
                                    margin-top: 0.5rem;
                                    i{
                                        background:rgba(255,12,77,1);
                                    }
                                }
                                i{
                                    margin-left: 1rem;
                                    display: inline-block;
                                    width:0.33rem;
                                    height:0.33rem;
                                    border-radius:50%;
                                }
                                .span1{
                                    margin-left: 0.8rem;
                                    font-size:1rem;
                                    font-family:AlibabaPuHuiTiR;
                                    color:rgba(51,51,51,1);
                                }
                                .span2{
                                    margin-right: 1rem;
                                    font-size:1rem;
                                    font-family:AlibabaPuHuiTiR;
                                    color:rgba(101,112,133,1);
                                }
                            }
                        }
                        .div2{
                            position:absolute;
                            top: 7.5rem;left: 3.3rem;
                            display: flex;
                            width:14.7rem;
                            height:3.33rem;
                            background:rgba(246,248,250,1);
                            text-align: center;
                            display: none;
                            div{
                                flex: 1;
                                img{
                                    margin-top: 0.5rem;
                                    height: 1rem;
                                }
                                p{
                                    font-size:1rem;
                                    font-family:AlibabaPuHuiTiR;
                                    color:rgba(51,51,51,1);
                                }
                                &.circadianLights{
                                    img{
                                        margin-top: 0.8rem;
                                        height: 0.7rem;
                                    }
                                }
                            }
                        }
                        .div3{
                            position:absolute;
                            top: 7.5rem;left: 0;
                            width:3.3rem;
                            height:3.33rem;
                            background:rgba(5,207,171,1);
                            border-radius:0rem 0rem 0rem 0.17rem;
                            display: flex;align-items: center;
                            justify-content: center;
                            i{
                                color:#fff;
                            }
                        }
                    }
                    .frame_selection{
                        position:absolute;
                        border:1px solid rgba(5,207,171,1);
                        background:rgba(5,207,171,0.2);
                        .move{
                            position:absolute;
                            right: 0rem;bottom:0;
                            width: 1.25rem;
                            height: 1.25rem;
                            border-radius:50%;
                            border:0.08rem solid rgba(5,207,171,1);
                            background-position:center;
                            background-size:100% 100%;
                            background-image:url('../img/room/map/move.png');
                            cursor: pointer;
                        }
                    }
                    .map_device{
                        position:absolute;
                        width: 3rem;height: 3rem;
                        background-position:center;
                        background-size:100% 100%;
                        cursor: pointer;
                        &.type_0{
                            &.status_0{
                                background-image:url('../img/room/map/map_device_0_0.png');
                                &:hover{
                                    background-image:url('../img/room/map/map_device_0_0_hover.png');
                                }
                                &.frameSelection_1{
                                    background-image:url('../img/room/map/map_device_0_0_hover.png');
                                }
                            }
                            &.status_1{
                                background-image:url('../img/room/map/map_device_0_1.png');
                                &:hover{
                                    background-image:url('../img/room/map/map_device_0_1_hover.png');
                                }
                                &.frameSelection_1{
                                    background-image:url('../img/room/map/map_device_0_1_hover.png');
                                }
                            }
                            &.status_new{
                                background-image:url('../img/room/map/map_device_0_new.png');
                                &:hover{
                                    background-image:url('../img/room/map/map_device_0_new_hover.png');
                                }
                                &.frameSelection_1{
                                    background-image:url('../img/room/map/map_device_0_new_hover.png');
                                }
                            }
                        }
                        &.type_1{
                            &.status_0{
                                background-image:url('../img/room/map/map_device_1_0.png');
                                &:hover{
                                    background-image:url('../img/room/map/map_device_1_0_hover.png');
                                }
                                &.frameSelection_1{
                                    background-image:url('../img/room/map/map_device_1_0_hover.png');
                                }
                            }
                            &.status_1{
                                background-image:url('../img/room/map/map_device_1_1.png');
                                &:hover{
                                    background-image:url('../img/room/map/map_device_1_1_hover.png');
                                }
                                &.frameSelection_1{
                                    background-image:url('../img/room/map/map_device_1_1_hover.png');
                                }
                            }
                            &.status_new{
                                background-image:url('../img/room/map/map_device_1_new.png');
                                &:hover{
                                    background-image:url('../img/room/map/map_device_1_new_hover.png');
                                }
                                &.frameSelection_1{
                                    background-image:url('../img/room/map/map_device_1_new_hover.png');
                                }
                            }
                        }
                        &.type_2{
                            &.status_0{
                                background-image:url('../img/room/map/map_device_2_0.png');
                                &:hover{
                                    background-image:url('../img/room/map/map_device_2_0_hover.png');
                                }
                                &.frameSelection_1{
                                    background-image:url('../img/room/map/map_device_2_0_hover.png');
                                }
                            }
                            &.status_1{
                                background-image:url('../img/room/map/map_device_2_1.png');
                                &:hover{
                                    background-image:url('../img/room/map/map_device_2_1_hover.png');
                                }
                                &.frameSelection_1{
                                    background-image:url('../img/room/map/map_device_2_1_hover.png');
                                }
                            }
                            &.status_new{
                                background-image:url('../img/room/map/map_device_2_new.png');
                                &:hover{
                                    background-image:url('../img/room/map/map_device_2_new_hover.png');
                                }
                                &.frameSelection_1{
                                    background-image:url('../img/room/map/map_device_2_new_hover.png');
                                }
                            }
                        }
                        &.type_3{
                            &.status_0{
                                background-image:url('../img/room/map/map_device_3_0.png');
                                &:hover{
                                    background-image:url('../img/room/map/map_device_3_0_hover.png');
                                }
                                &.frameSelection_1{
                                    background-image:url('../img/room/map/map_device_3_0_hover.png');
                                }
                            }
                            &.status_1{
                                background-image:url('../img/room/map/map_device_3_1.png');
                                &:hover{
                                    background-image:url('../img/room/map/map_device_3_1_hover.png');
                                }
                                &.frameSelection_1{
                                    background-image:url('../img/room/map/map_device_3_1_hover.png');
                                }
                            }
                            &.status_new{
                                background-image:url('../img/room/map/map_device_3_new.png');
                                &:hover{
                                    background-image:url('../img/room/map/map_device_3_new_hover.png');
                                }
                                &.frameSelection_1{
                                    background-image:url('../img/room/map/map_device_3_new_hover.png');
                                }
                            }
                        }
                        &.type_4{
                            &.status_0{
                                background-image:url('../img/room/map/map_device_0_0.png');
                                &:hover{
                                    background-image:url('../img/room/map/map_device_0_0_hover.png');
                                }
                                &.frameSelection_1{
                                    background-image:url('../img/room/map/map_device_0_0_hover.png');
                                }
                            }
                            &.status_1{
                                background-image:url('../img/room/map/map_device_0_1.png');
                                &:hover{
                                    background-image:url('../img/room/map/map_device_0_1_hover.png');
                                }
                                &.frameSelection_1{
                                    background-image:url('../img/room/map/map_device_0_1_hover.png');
                                }
                            }
                            &.status_new{
                                background-image:url('../img/room/map/map_device_0_new.png');
                                &:hover{
                                    background-image:url('../img/room/map/map_device_0_new_hover.png');
                                }
                                &.frameSelection_1{
                                    background-image:url('../img/room/map/map_device_0_new_hover.png');
                                }
                            }
                        }
                        &.type_5{
                            &.status_0{
                                background-image:url('../img/room/map/map_device_0_0.png');
                                &:hover{
                                    background-image:url('../img/room/map/map_device_0_0_hover.png');
                                }
                                &.frameSelection_1{
                                    background-image:url('../img/room/map/map_device_0_0_hover.png');
                                }
                            }
                            &.status_1{
                                background-image:url('../img/room/map/map_device_0_1.png');
                                &:hover{
                                    background-image:url('../img/room/map/map_device_0_1_hover.png');
                                }
                                &.frameSelection_1{
                                    background-image:url('../img/room/map/map_device_0_1_hover.png');
                                }
                            }
                            &.status_new{
                                background-image:url('../img/room/map/map_device_0_new.png');
                                &:hover{
                                    background-image:url('../img/room/map/map_device_0_new_hover.png');
                                }
                                &.frameSelection_1{
                                    background-image:url('../img/room/map/map_device_0_new_hover.png');
                                }
                            }
                        }
                        &.type_6{
                            &.status_0{
                                background-image:url('../img/room/map/map_device_0_0.png');
                                &:hover{
                                    background-image:url('../img/room/map/map_device_0_0_hover.png');
                                }
                                &.frameSelection_1{
                                    background-image:url('../img/room/map/map_device_0_0_hover.png');
                                }
                            }
                            &.status_1{
                                background-image:url('../img/room/map/map_device_0_1.png');
                                &:hover{
                                    background-image:url('../img/room/map/map_device_0_1_hover.png');
                                }
                                &.frameSelection_1{
                                    background-image:url('../img/room/map/map_device_0_1_hover.png');
                                }
                            }
                            &.status_new{
                                background-image:url('../img/room/map/map_device_0_new.png');
                                &:hover{
                                    background-image:url('../img/room/map/map_device_0_new_hover.png');
                                }
                                &.frameSelection_1{
                                    background-image:url('../img/room/map/map_device_0_new_hover.png');
                                }
                            }
                        }
                        &.type_7{
                            &.status_0{
                                background-image:url('../img/room/map/map_device_0_0.png');
                                &:hover{
                                    background-image:url('../img/room/map/map_device_0_0_hover.png');
                                }
                                &.frameSelection_1{
                                    background-image:url('../img/room/map/map_device_0_0_hover.png');
                                }
                            }
                            &.status_1{
                                background-image:url('../img/room/map/map_device_0_1.png');
                                &:hover{
                                    background-image:url('../img/room/map/map_device_0_1_hover.png');
                                }
                                &.frameSelection_1{
                                    background-image:url('../img/room/map/map_device_0_1_hover.png');
                                }
                            }
                            &.status_new{
                                background-image:url('../img/room/map/map_device_0_new.png');
                                &:hover{
                                    background-image:url('../img/room/map/map_device_0_new_hover.png');
                                }
                                &.frameSelection_1{
                                    background-image:url('../img/room/map/map_device_0_new_hover.png');
                                }
                            }
                        }
                        // &.status_new{
                        //     background-image:url('../img/room/map_device_new.png');
                        //     &:hover{
                        //         background-image:url('../img/room/map_device_hover.png');
                        //     }
                        // }
                    }
                }
                .room_right_main_r{
                    width: calc(100% - 2rem);
                    margin-left: 1.5rem;
                    .ul{
                        display: flex;
                        flex-wrap: wrap;
                        align-content: flex-start;
                    }
                    >p{
                        text-align:center;
                    }
                    .li{
                        width: calc(33.33% - 1.7rem);height: 14rem;
                        background-image: url('../img/room_bg.png');
                        background-position: center;
                        background-size: 100% 100%;
                        border-radius: 1rem;
                        margin-right: 2rem;
                        margin-bottom: 1.67rem;
                        cursor: pointer;
                        position: relative;
                        &:hover{
                            box-shadow: 0.1rem 0.1rem 0.3rem #bbb;
                        }
                        &:nth-child(3n){
                            margin-right: 1.1rem;
                        }
                        .seting_btn{
                            position: absolute;
                            top: 0.2rem;
                            right: 1rem;
                            height: 1.5rem;
                            line-height:1.5rem;
                            background: #fff;
                            border-radius: 0.2rem;
                            width: 1.5rem;
                            font-size: 1rem;
                            text-align: center;
                        }
                        .box1{
                            display: flex;
                            justify-content: space-between;
                            .img_box{
                                margin-left: 0.4rem;
                                width:6.83rem;height: 6.83rem;
                                border-radius: 0.68rem;
                                overflow: hidden;
                                img{
                                    width: 100%;height: 100%;
                                }
                            }
                            .lightsNumber{
                                display: flex;
                                text-align: center;
                                width: 16rem;
                                margin-top: 3rem;
                                >div{
                                    flex: 1;
                                    margin: 0 0.2rem;
                                }
                                .p1{
                                    // margin-top: 0.5rem;
                                    font-family: AlibabaPuHuiTiR;
                                    font-size: 0.9rem;
                                    color: #FFFFFF;
                                    height: 2.5rem;
                                }
                                .p2{
                                    font-family: AlibabaPuHuiTiH;
                                    font-size: 0.9rem;
                                    color: #FFFFFF;
                                }

                            }
                            .text_box{
                                margin-left: auto;
                                width: 7rem;
                                text-align: left;
                                .p1{
                                    margin-top: -0.7rem;
                                    font-family: AlibabaPuHuiTiH;
                                    font-size: 1.8rem;
                                    color: #FFFFFF;
                                    overflow: hidden;
                                    text-overflow:ellipsis;
                                    white-space: nowrap;
                                }
                                .p2{
                                    margin-top: 2.2rem;
                                    font-family: AlibabaPuHuiTiR;
                                    font-size: 1.4rem;
                                    color: rgba(255,255,255,0.7);
                                }
                            }
                        }
                        .box2{
                            margin:0.67rem 1.5rem 0 1.42rem;
                            display: flex;
                            text-align: center;
                            >div{
                                height: 5.5rem;
                                &:nth-child(1){
                                    .p2{
                                        border-top-left-radius: 2rem;
                                        border-bottom-left-radius: 2rem;
                                    }
                                }
                                &:nth-child(7){
                                    .p2{
                                        border-top-right-radius: 2rem;
                                        border-bottom-right-radius: 2rem;
                                    }
                                }
                            }
                            .div1{
                                flex: 1;
                                border-radius: 0.5rem 0 0 0.5rem;
                                // background: rgba(255,255,255,0.4);
                            }
                            .div2,.div3{
                                flex: 1;
                                // background: rgba(255,255,255,0.4);
                            }
                            .p1{
                                line-height:1.2rem;
                                margin-top: 0.5rem;
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #FFFFFF;
                            }
                            .p2{
                                margin: 0.2rem 0 0.2rem 0;
                                line-height:2rem;
                                font-family: AlibabaPuHuiTiH;
                                font-size: 1.2rem;
                                color: #FFE835;
                                background-color:#0D70BA;
                            }
                            .p3{
                                // font-family: AlibabaPuHuiTiH;
                                font-size: 0.9rem;
                                color: #FFFFFF;
                            }
                            .div4{
                                flex: 1;
                                .p2{
                                    color: #fff;
                                }
                            }
                            // .div4{
                            //  flex: 1;
                            //  border: 1px solid rgba(255,255,255,0.3);
                            //  border-radius: 0 0.5rem 0.5rem 0;
                            //  .p2{
                            //      font-family: AlibabaPuHuiTiH;
                            //      font-size: 1.2rem;
                            //      color: #FFE835;
                            //  }
                            // }
                        }
                    }
                }
            }
        }
        .mapEditDevice{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .mapEditDevice_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .mapEditDevice_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 1s;
                &.mapEditDevice_tk_show{
                    right: 0rem; 
                }
                .mapEditDevice_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .form{
                    margin-top: 2.46rem;
                    .form_item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 3.33rem;line-height: 3.33rem;
                        margin: 0 2.5rem 1.67rem;
                        padding: 0 1.67rem 0 1.08rem;
                        background: #F6F8F7;
                        .laber{
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .el-dropdown{
                            cursor: pointer;
                            i{
                                margin-left: 1.67rem;
                            }
                        }
                        .el-input{
                            width: calc(100% - 9.5rem);
                            .el-input__inner{
                                text-align: right;
                                background: initial;
                                border: none;
                            }
                        }
                        .form_item_left{
                            display: flex;
                            align-items: center;
                            .pl_switch{
                                position: relative;
                                display: inline-block;
                                width: 2.33rem;
                                height: 1.3rem;
                                background: #E1EAF1;
                                border-radius: 1.08rem;
                                cursor: pointer;
                                &::after{
                                    position: absolute;
                                    left: 0.2rem;top: 0.15rem;
                                    width: 0.93rem;height: 0.93rem;border-radius: 50%;
                                    content: '';
                                    background: #A3AFBB;
                                    transition: all 0.5s;
                                }
                                &.checked{
                                    background: #E1F1E7;
                                    &::after{
                                        left: 1.15rem;
                                        background: #05CFAB;
                                    }
                                }
                            }
                            .el-dropdown{
                                margin-left: 0.83rem;
                                cursor: pointer;
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #657085;
                            }
                        }
                    }
                    .arrangement{
                        margin: 1.67rem 2.5rem;
                    }
                    .dashed{
                        margin: 1.67rem 2.5rem;
                        border:1px dashed #C6CDD5;
                    }
                }
                .btn{
                    width: 7.8rem;height: 2.67rem;line-height: 2.67rem;
                    margin: 0 0 0 2.5rem;
                    background: #05CFAB;
                    border-radius: 0.2rem;
                    text-align:center;
                    cursor: pointer;
                    font-family: PingFang-SC-Medium;
                    font-size: 1rem;
                    color: #FFFFFF;
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        margin: 0 auto;
                    }
                }
            }
        }
        .mapDevice{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .mapDevice_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 45rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .mapDevice_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 45rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 1s;
                &.mapDevice_tk_show{
                    right: 0rem; 
                }
                .mapDevice_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .form{
                    margin-top: 2.46rem;
                    .form_item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 3.33rem;line-height: 3.33rem;
                        margin: 0 2.5rem 1.67rem;
                        padding: 0 1.67rem 0 1.08rem;
                        background: #F6F8F7;
                        .laber{
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .el-dropdown{
                            cursor: pointer;
                            i{
                                margin-left: 1.67rem;
                            }
                        }
                        .el-input{
                            width: calc(100% - 8rem);
                            &.number{

                                .el-input__inner{
                                    padding-right: 1rem;
                                }
                            }
                            .el-input__inner{
                                text-align: right;
                                background: initial;
                                border: none;
                            }
                        }
                        .form_item_left{
                            display: flex;
                            align-items: center;
                            .pl_switch{
                                position: relative;
                                display: inline-block;
                                width: 2.33rem;
                                height: 1.3rem;
                                background: #E1EAF1;
                                border-radius: 1.08rem;
                                cursor: pointer;
                                &::after{
                                    position: absolute;
                                    left: 0.2rem;top: 0.15rem;
                                    width: 0.93rem;height: 0.93rem;border-radius: 50%;
                                    content: '';
                                    background: #A3AFBB;
                                    transition: all 0.5s;
                                }
                                &.checked{
                                    background: #E1F1E7;
                                    &::after{
                                        left: 1.15rem;
                                        background: #05CFAB;
                                    }
                                }
                            }
                            .el-dropdown{
                                margin-left: 0.83rem;
                                cursor: pointer;
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #657085;
                            }
                        }
                    }
                    .arrangement{
                        margin: 1.67rem 2.5rem;
                    }
                    .dashed{
                        margin: 1.67rem 2.5rem;
                        border-bottom:1px dashed #C6CDD5;
                    }
                }
                .btn{
                    // width: 7.8rem;
                    display: inline-block;
                    height: 2.67rem;line-height: 2.67rem;
                    padding: 0 0.5rem;
                    margin: 0 0 0 2.5rem;
                    background: #05CFAB;
                    border-radius: 0.2rem;
                    text-align:center;
                    cursor: pointer;
                    font-family: PingFang-SC-Medium;
                    font-size: 1rem;
                    color: #FFFFFF;
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    text-align: center;
                    .btn{
                        margin: 0 auto;
                        padding:0 2rem;
                    }
                }
            }
        }
        .centralizedSetting_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .centralizedSetting_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 66rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .centralizedSetting_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 66rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 1s;
                &.centralizedSetting_tk_show{
                    right: 0rem; 
                }
                .centralizedSetting_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .form{
                    margin-top: 2.46rem;
                    .form_item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 3.33rem;line-height: 3.33rem;
                        margin: 0 2.5rem 1.67rem;
                        padding: 0 1.67rem 0 1.08rem;
                        background: #F6F8F7;
                        .laber{
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .el-dropdown{
                            cursor: pointer;
                            i{
                                margin-left: 1.67rem;
                            }
                        }
                        .el-input{
                            width: calc(100% - 8rem);
                            .el-input__inner{
                                text-align: right;
                                background: initial;
                                border: none;
                            }
                        }
                        .form_item_left{
                            display: flex;
                            align-items: center;
                            .pl_switch{
                                position: relative;
                                display: inline-block;
                                width: 2.33rem;
                                height: 1.3rem;
                                background: #E1EAF1;
                                border-radius: 1.08rem;
                                cursor: pointer;
                                &::after{
                                    position: absolute;
                                    left: 0.2rem;top: 0.15rem;
                                    width: 0.93rem;height: 0.93rem;border-radius: 50%;
                                    content: '';
                                    background: #A3AFBB;
                                    transition: all 0.5s;
                                }
                                &.checked{
                                    background: #E1F1E7;
                                    &::after{
                                        left: 1.15rem;
                                        background: #05CFAB;
                                    }
                                }
                            }
                            .el-dropdown{
                                margin-left: 0.83rem;
                                cursor: pointer;
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #657085;
                            }
                        }
                        .li_l{
                            font-family: AlibabaPuHuiTiR;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .li_r{
                            display: flex;
                            align-items: center;
                            font-family: AlibabaPuHuiTiR;
                            font-size: 1rem;
                            color: #657085;
                            position: relative;
                            .pl_switch{
                                margin-left: 0.83rem;
                                position: relative;
                                display: inline-block;
                                width: 2.33rem;
                                height: 1.3rem;
                                background-color:#E1F1E7;
                                border-radius: 1.08rem;
                                cursor: pointer;
                                .el-loading-mask{
                                    background-color:rgba(255,255,255,0.4);
                                    .el-loading-spinner{
                                        margin-top: -1.4rem
                                    }
                                    .circular{
                                        width: 1.3rem;height: 1.3rem;
                                    }
                                }
                                &::after{
                                    position: absolute;
                                    left: 0.2rem;top: 0.2rem;
                                    width: 0.93rem;height: 0.93rem;border-radius: 50%;
                                    content: '';
                                    background-color:#a3afbb;
                                    transition: all 0.5s;
                                }
                                &.checked{
                                    background-color:#E1F1E7;
                                   &::after{
                                        left: 1.15rem;
                                        background-color:#05CFAB;
                                   } 
                                }
                            }
                            .el-dropdown{
                                width: 6rem;
                                margin-left: 0.83rem;
                                cursor: pointer;
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #657085;
                                text-align: right;
                                i{
                                    margin-left: 0.5rem;
                                }
                            }
                            .disabled{
                                position: absolute;
                                display: inline-block;
                                width: 100%;
                                height: 100%;
                                top: 0;
                                left: 0;
                                cursor: no-drop;
                            }
                        }
                    }
                    .form_item1{
                        margin: 0 2.5rem 1.67rem;
                        .p1{
                            font-family: AlibabaPuHuiTiR;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .p2{
                            font-family: AlibabaPuHuiTiB;
                            font-size: 1.67rem;
                            color: #333333;
                        }
                        .slider1{
                            .el-slider__bar{
                                background-color:#05CFAB;
                            }
                            .el-slider__button{
                                border: 3px solid #FFFFFF;
                                background-color: #05CFAB;
                            }
                        }
                        .slider2{
                            .el-slider__bar{
                                background-color:#FFBE00;
                            }
                            .el-slider__button{
                                border: 3px solid #FFFFFF;
                                background-color: #FFBE00;
                            }
                        }
                        .slider3{
                            .el-slider__runway{
                                background: linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)
                            }
                            .el-slider__bar{
                                background-color:rgba(0,0,0,0);
                            }
                        }
                        .color-svpanel{
                            margin: 0 auto;
                            width: 100%;
                            height: 7.5rem;
                            position: relative;
                            .color-svpanel__white{
                                position: absolute;
                                top: 0;left:0;right:0;bottom:0;
                                background:linear-gradient(90deg,#fff,hsla(0,0%,100%,0));
                            }
                            .color-svpanel__black{
                                position: absolute;
                                top: 0;left:0;right:0;bottom:0;
                                background:linear-gradient(0deg,#000,transparent);
                            }
                            .color-svpanel__cursor{
                                position: absolute;
                                cursor: pointer;
                                width: 0.8rem;
                                height: 0.8rem;
                                box-shadow: 0 0 0 0.05rem rgba(0,0,0,0.4),;
                                border: 0.15rem solid #FFFFFF;
                                border-radius: 50%;
                                transform: translate(-0.4rem,-0.4rem);
                            }
                        }
                        .rgb_box{
                            width: 100%;height: 2rem;line-height: 2rem;
                            display: flex;
                            background: #F6F8FA;
                            border: 1px solid #EBEFF2;
                            border-radius: 0 0 0.3rem 0.3rem;
                            .leber{
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #333333;
                            }
                            .r,.b,.g{
                                display: flex;
                                justify-content: space-between;
                                flex:1;
                                padding: 0 1rem;
                            }
                        }
                    }
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #05CFAB;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #FFFFFF;
                    }
                }
            }
        }
        .floorPlan_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .floorPlan_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 55rem;
                background-color:rgba(57,57,57,0.3);
            }
            .floorPlan_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 55rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 1s;
                &.floorPlan_tk_show{
                    right: 0rem; 
                }
                .floorPlan_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .floorPlan_topNav{
                    display: flex;
                    width: 11.75rem;height: 2.75rem;line-height: 2.75rem;
                    text-align:center;
                    margin: 1.67rem auto 1.67rem;
                    background: #F6F8FA;
                    border-radius: 1.38rem;
                    font-family: AlibabaPuHuiTiR;
                    font-size: 1rem;
                    color: #333333;
                    .li{
                        flex: 1;
                        cursor: pointer;
                        &.select{
                            color: #FFFFFF;
                            border-radius: 1.38rem;
                            background: #05CFAB;
                        }
                    }
                }
                .img_bg{
                    width: calc(100% - 5rem);
                    margin: 0 2.5rem;
                    img{
                        width: 100%;max-height: 100%;
                    }
                }
            }
        }
        .roomPlan_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .roomPlan_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 30rem;
                background-color:rgba(57,57,57,0.3);
            }
            .roomPlan_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 30rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 1s;
                &.roomPlan_tk_show{
                    right: 0rem; 
                }
                .roomPlan_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .div{
                    margin: 1rem 1.5rem 0;
                    background: #F6F8F7;
                    height: 3.5rem;line-height:3.5rem;
                    border-radius: 2px;
                    // margin: 0 1.5rem 0.83rem;
                    padding: 0 1rem;
                    display: flex;
                    justify-content: space-between;
                    font-family: AlibabaPuHuiTiR;
                    font-size: 1rem;
                    .span1{
                        color: #333333;
                    }
                    .span2{
                        color: #657085;
                        max-width: calc(100% - 6rem);
                        display: inline-block;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        vertical-align: middle;
                    }
                    .el-dropdown{
                        max-width:calc(100% - 11rem);
                        cursor: pointer;
                        .el-dropdown-link{
                            display: inline-block;
                            display: flex;
                            align-items: center;
                            height:100%;
                            span{
                                overflow: hidden;
                                text-overflow:ellipsis;
                                white-space: nowrap;
                                display: inline-block;

                            }
                        }
                    }
                }
            }
        }
        .map_binding_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .map_binding_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            .tk_box{
                position: absolute;
                width: 35rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -35rem;
                transition: all 0.8s;
                &.tk_show{
                    right: 0rem; 
                }
                .tk_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .switch_box{
                    height:2.75rem;line-height: 2.75rem;
                    display: flex;
                    margin-right: 1rem;
                    width:22rem;
                    background:rgba(246,248,250,1);
                    border-radius:1.38rem;
                    margin: 1.5rem auto 2.5rem;
                    .div{
                        cursor: pointer;
                        flex: 1;
                        text-align: center;
                        font-size:1rem;
                        font-family:AlibabaPuHuiTiR;
                        color:rgba(51,51,51,1);
                        height:2.35rem;line-height: 2.35rem;
                        margin-top: 0.2rem;
                        &.select{
                            color:rgba(255,255,255,1);
                            background:rgba(5,207,171,1);
                            border-radius:1.67rem;
                        }
                    }
                }
                .form{
                    height: calc(100% - 17rem);
                    margin-top: 1.96rem;
                    .box{
                        height: 100%;
                    }
                    .tabs1{
                        position: relative;
                        text-align: center;
                        width:calc(100% - 5rem);
                        height:3.33rem;line-height: 3.33rem;
                        border-radius:0.17rem;
                        margin: 0 2.5rem;
                        padding: 0 1.67rem;
                        display: flex;
                        justify-content: space-between;
                        align-items:center;
                        background:rgba(246,248,250,1);
                        .span1{
                            font-size:1.17rem;
                            font-family:AlibabaPuHuiTiM;
                            color:rgba(51,51,51,1);
                        }
                        .span2{
                            display: inline-block;
                            width: 2.5rem;height: 2.5rem;
                            line-height: 2.8rem;
                            border-radius:50%;
                            background:rgba(235,239,242,1);
                            cursor: pointer;
                            i{
                                font-size:1.5rem;
                                color:#A3AFBB; 
                            }
                            &.select{
                                background:rgba(5,207,171,1);
                                i{
                                    color: #FFFFFF;
                                }
                            }
                        }
                    }
                    .ul{
                        margin-top: 2rem;
                        height: calc(100% - 5.33rem);
                        .li{
                            display: flex;
                            justify-content: space-between;
                            margin-bottom: 2.5rem;
                            .l{
                                display: flex;
                            }
                            .img_box{
                                margin-left: 3rem;
                                width: 4.2rem;height: 4.2rem;
                                display: flex;
                                align-items:center;
                                border-radius: 50%;
                                overflow: hidden;
                                background-color: rgba(246, 248, 250, 1);
                                .img{
                                    margin: 0 auto;
                                    width: 40%;
                                    display: flex;
                                    align-items: center;
                                    img{
                                        width: 100%;
                                    }
                                    
                                }
                            }
                            .text_box{
                                margin-left: 1.67rem;
                                .p1{
                                    margin-top: 0.5rem;
                                    line-height: 1.67rem;
                                    font-size:1.17rem;
                                    font-family:AlibabaPuHuiTiR;
                                    color:rgba(51,51,51,1);
                                }
                                .p2{
                                    font-size:1rem;
                                    font-family:AlibabaPuHuiTiR;
                                    color:rgba(101,112,133,1);
                                    line-height:1.42rem;
                                    i{
                                        margin: 0.2rem 0.8rem 0;
                                        display: inline-block;
                                        width: 0.15rem;
                                        height: 0.8rem;
                                        background-color:rgba(235, 239, 242, 1);
                                    }
                                }
                            }
                            .r{
                                display: flex;
                                align-items: center;
                                .btn{
                                    text-align: center;
                                    margin-right: 2.25rem;
                                    width: 2.5rem;height: 2.5rem;
                                    cursor: pointer;
                                    border-radius:50%;
                                    background:rgba(246,248,250,1);
                                    i{
                                        line-height: 2.5rem;
                                        font-size:1.5rem;
                                        color:#A3AFBB; 
                                    }
                                    &.select{
                                        background:rgba(5,207,171,1);
                                        i{
                                            color: #FFFFFF;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .tabs2{
                        position: relative;
                        text-align: left;
                        width:calc(100% - 5rem);
                        height:4.42rem;line-height: 1.9rem;
                        padding-top:0.5rem;
                        padding-left:3rem;
                        border-radius:0.17rem;
                        margin: 0 2.5rem;
                        background:rgba(5,207,171,0.1);

                        .span1{
                            position:absolute;
                            left: 1rem;top: 1.6rem;
                            display: inline-block;
                            width:1.13rem;
                            height:1.13rem;line-height: 1.13rem;
                            border-radius: 50%;
                            background:rgba(5,207,171,1);
                            font-weight:500;
                            color: #fff;
                            text-align: center;
                        }
                        .span2{
                            font-size:1rem;
                            font-family:PingFang-SC-Medium,PingFang-SC;
                            font-weight:500;
                            color:rgba(51,51,51,1); 
                            .span3{
                                color: #05CFAB;
                                text-decoration:underline;
                                cursor: pointer;
                            }
                        }
                    }
                    .avatar-uploader{
                        width:calc(100% - 5rem);
                        margin: 1.67rem auto 0;
                        height:7rem;line-height: 7rem;
                        background:rgba(246,248,247,1);
                        border:0.08rem dashed rgba(101,112,133,0.5);
                        .el-upload{
                            text-align: center;
                            width: 100%;height: 100%;

                            font-size:1rem;
                            font-family:PingFang-SC-Medium,PingFang-SC;
                            font-weight:500;
                            color:rgba(119,130,151,1);
                            .icon-shangchuan{
                                font-size: 1.2rem;
                                margin-right: 0.83rem;
                            }
                        }
                    }
                    .upload_progress{
                        width:calc(100% - 5rem);
                        margin: 1.67rem auto 0;
                        display: flex;
                        justify-content: space-between;
                        .l{
                            display: flex;
                        }
                        .i_box{
                            margin-right: 0.5rem;
                            width:1.5rem;text-align: center;
                            height:1.5rem;line-height: 1.5rem;
                            border-radius: 50%;
                            background:rgba(235,239,242,1);
                            color: rgba(198, 205, 213, 1);
                        }
                        .text{
                            margin-right: 2rem;
                            font-size:1rem;
                            font-family:PingFang-SC-Medium,PingFang-SC;
                            font-weight:500;
                            color:rgba(51,51,51,1);
                        }
                        .el-progress{
                            width: 16rem;height: 2rem;line-height: 2rem;
                            .el-progress-bar{
                                margin-top: 0.4rem;
                            }
                        }
                    }
                    .success{
                        .box{
                            width:calc(100% - 5rem);
                            margin: 1.67rem auto 0;
                            display: flex;
                            justify-content: space-between;
                            .l{
                                display: flex;
                            }
                            .i_box{
                                margin-right: 0.5rem;
                                width:1.5rem;text-align: center;
                                height:1.5rem;line-height: 1.5rem;
                                img{
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .text1{
                                margin-right: 1rem;
                                font-size:1rem;
                                font-family:PingFang-SC-Heavy,PingFang-SC;
                                font-weight:800;
                                color:rgba(51,51,51,1);
                            }
                            .text2{
                                font-size:1rem;
                                font-family:PingFang-SC-Heavy,PingFang-SC;
                                font-weight:800;
                                color:rgba(101,112,133,1);
                                max-width: 14rem;
                                display: inline-block;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                            .text3{
                                margin-left:2rem;
                                font-size:1rem;
                                font-family:PingFang-SC-Heavy,PingFang-SC;
                                font-weight:800;
                                color:rgba(101,112,133,1);
                            }
                        }
                        .logo_box{
                            width:calc(100% - 5rem);
                            margin: 1.67rem auto 0;
                            img{
                                width: 100%;
                                max-height: 10rem;
                            }
                        }
                    }
                    .error{
                        .box{
                            width:calc(100% - 5rem);
                            margin: 1.67rem auto 0;
                            display: flex;
                            justify-content: space-between;
                            .l{
                                display: flex;
                            }
                            .i_box{
                                margin-right: 0.5rem;
                                width:1.5rem;text-align: center;
                                height:1.5rem;line-height: 1.5rem;
                                img{
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .text1{
                                margin-right: 1rem;
                                font-size:1rem;
                                font-family:PingFang-SC-Heavy,PingFang-SC;
                                font-weight:800;
                                color:rgba(51,51,51,1);
                            }
                            .text2{
                                font-size:1rem;
                                font-family:PingFang-SC-Heavy,PingFang-SC;
                                font-weight:800;
                                color:rgba(101,112,133,1);
                                max-width: 14rem;
                                display: inline-block;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                            .text3{
                                margin-left:2rem;
                                font-size:1rem;
                                font-family:PingFang-SC-Heavy,PingFang-SC;
                                font-weight:800;
                                color:rgba(101,112,133,1);
                            }
                        }
                    }
                    .el-table{
                        width: calc(100% - 5rem);
                        margin: 0 2.5rem;
                        th,td{
                            font-style: 12px;
                        }
                    }
                    .error_title{
                        margin: 0 2rem 1rem;
                        i{
                            color: rgba(234,86,80,1);
                            font-size: 2.3rem;
                            position: relative;
                            top: 0.3rem;
                            margin-right: 1.2rem;
                        }
                    }
                    .error_box{
                        height: calc(100% - 5rem);
                        margin: 0 2rem;
                        span{
                            display: inline-block;
                            font-family:PingFang-SC-Medium;
                            font-weight:normal;
                            color:rgba(128,86,86,1);
                            background:rgba(250,245,245,1);
                            font-size:1.2rem;
                            height: 3.2rem;
                            line-height:3.2rem;
                            padding: 0px 1.7rem 0px 1.1rem;
                            margin: 0 1rem 1rem 0;
                        }
                    }
                    .verify_success{
                        text-align: center;
                    }
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #05CFAB;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #FFFFFF;
                    }
                }
            }
        }
        .map_floorplan_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .map_floorplan_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            .tk_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 0.8s;
                &.tk_show{
                    right: 0rem; 
                }
                .tk_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .form{
                    margin-top: 1.96rem;
                    .form_item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 3.33rem;line-height: 3.33rem;
                        margin: 0 2.5rem 1.67rem;
                        padding: 0 1.67rem 0 1.08rem;
                        background: #F6F8F7;
                        &.no_bg{
                            background-color:initial;
                        }
                        .laber{
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .el-dropdown{
                            cursor: pointer;
                            i{
                                margin-left: 1.67rem;
                            }
                        }
                        .el-input{
                            width: calc(100% - 8rem);
                            .el-input__inner{
                                font-family: PingFang-SC-Medium;
                                font-size: 1rem;
                                color: #657085;
                                text-align: right;
                                background: initial;
                                border: none;
                            }
                        }
                    }
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #05CFAB;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #FFFFFF;
                    }
                }
            }
            .tabs{
                position: relative;
                text-align: center;
                width:calc(100% - 5rem);
                height:3.33rem;line-height: 3.33rem;
                border-radius:0.17rem;
                margin: 0 2.5rem;
                background:rgba(5,207,171,0.1);

                .span1{
                    display: inline-block;
                    margin-right:1rem;
                    width:1.13rem;
                    height:1.13rem;line-height: 1.13rem;
                    border-radius: 50%;
                    background:rgba(5,207,171,1);
                    font-weight:500;
                    color: #fff;
                    text-align: center;
                }
                .span2{
                    font-size:1rem;
                    font-family:PingFang-SC-Medium,PingFang-SC;
                    font-weight:500;
                    color:rgba(51,51,51,1); 
                }
            }
            .avatar-uploader{
                width:calc(100% - 5rem);
                margin: 1.67rem auto 0;
                height:7rem;line-height: 7rem;
                background:rgba(246,248,247,1);
                border:0.08rem dashed rgba(101,112,133,0.5);
                .el-upload{
                    text-align: center;
                    width: 100%;height: 100%;

                    font-size:1rem;
                    font-family:PingFang-SC-Medium,PingFang-SC;
                    font-weight:500;
                    color:rgba(119,130,151,1);
                    .icon-shangchuan{
                        font-size: 1.2rem;
                        margin-right: 0.83rem;
                    }
                }
            }
            .upload_progress{
                width:calc(100% - 5rem);
                margin: 1.67rem auto 0;
                display: flex;
                justify-content: space-between;
                .l{
                    display: flex;
                }
                .i_box{
                    margin-right: 0.5rem;
                    width:1.5rem;text-align: center;
                    height:1.5rem;line-height: 1.5rem;
                    border-radius: 50%;
                    background:rgba(235,239,242,1);
                    color: rgba(198, 205, 213, 1);
                }
                .text{
                    margin-right: 2rem;
                    font-size:1rem;
                    font-family:PingFang-SC-Medium,PingFang-SC;
                    font-weight:500;
                    color:rgba(51,51,51,1);
                }
                .el-progress{
                    width: 16rem;height: 2rem;line-height: 2rem;
                    .el-progress-bar{
                        margin-top: 0.4rem;
                    }
                }
            }
            .success{
                .box{
                    width:calc(100% - 5rem);
                    margin: 1.67rem auto 0;
                    display: flex;
                    justify-content: space-between;
                    .l{
                        display: flex;
                    }
                    .i_box{
                        margin-right: 0.5rem;
                        width:1.5rem;text-align: center;
                        height:1.5rem;line-height: 1.5rem;
                        img{
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .text1{
                        margin-right: 1rem;
                        font-size:1rem;
                        font-family:PingFang-SC-Heavy,PingFang-SC;
                        font-weight:800;
                        color:rgba(51,51,51,1);
                    }
                    .text2{
                        font-size:1rem;
                        font-family:PingFang-SC-Heavy,PingFang-SC;
                        font-weight:800;
                        color:rgba(101,112,133,1);
                        max-width: 14rem;
                        display: inline-block;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    .text3{
                        margin-left:2rem;
                        font-size:1rem;
                        font-family:PingFang-SC-Heavy,PingFang-SC;
                        font-weight:800;
                        color:rgba(101,112,133,1);
                    }
                }
                .logo_box{
                    width:calc(100% - 5rem);
                    margin: 1.67rem auto 0;
                    img{
                        width: 100%;
                        max-height: 10rem;
                    }
                }
            }
            .error{
                .box{
                    width:calc(100% - 5rem);
                    margin: 1.67rem auto 0;
                    display: flex;
                    justify-content: space-between;
                    .l{
                        display: flex;
                    }
                    .i_box{
                        margin-right: 0.5rem;
                        width:1.5rem;text-align: center;
                        height:1.5rem;line-height: 1.5rem;
                        img{
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .text1{
                        margin-right: 1rem;
                        font-size:1rem;
                        font-family:PingFang-SC-Heavy,PingFang-SC;
                        font-weight:800;
                        color:rgba(51,51,51,1);
                    }
                    .text2{
                        font-size:1rem;
                        font-family:PingFang-SC-Heavy,PingFang-SC;
                        font-weight:800;
                        color:rgba(101,112,133,1);
                        max-width: 14rem;
                        display: inline-block;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    .text3{
                        margin-left:2rem;
                        font-size:1rem;
                        font-family:PingFang-SC-Heavy,PingFang-SC;
                        font-weight:800;
                        color:rgba(101,112,133,1);
                    }
                }
            }
            .dashed{
                margin: 1.67rem 2.5rem;
                border-bottom:1px dashed #C6CDD5;
            }
            .item_title{
                display: flex;
                align-items:center;
                width:calc(100% - 5rem);
                margin: 1.67rem auto 1rem;
                .div{
                    width:1.33rem;
                    height:1.33rem;
                    border-radius:50%;
                    background:rgba(246,248,247,1);
                    text-align: center;
                    i{
                        display: inline-block;
                        width:0.67rem;
                        height:0.67rem;
                        border-radius:50%;
                        background:rgba(5,207,171,1);
                    }
                }
                .span{
                    margin-left: 0.67rem;
                    font-size:1rem;
                    font-family:PingFang-SC-Medium,PingFang-SC;
                    font-weight:500;
                    color:rgba(51,51,51,1);
                }
            }
        }
    }
</style>